<template>
    <div>
        <!--tabs-->
        <nav class="border-bottom position-relative d-flex justify-content-between">
            <v-tabs show-arrows>
                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                <v-tab class="" :class="{ active: selected_index == index }" v-for="(item, index) in inboxes" v-bind:key="index"
                    @click="nodeClicked(item)">
                    <span v-if="index !== 0" v-tooltip="item.fullname" class="inbox_tab_name">
                        {{ item.name }}
                    </span>
                    <span v-if="index === 0" class="inbox_tab_name">{{ item.name }}</span>
                    <span>&nbsp;({{ item.count }})</span>
                </v-tab>
            </v-tabs>
            <div class="d-flex gap-75 align-items-center grid-list-actions filters">
                <v-chip closable @click:close="chip = false" v-for="(item, index) in filterList"
                    v-bind:key="index">

                    {{ item.value.name?item.value.name:item.value }}
                    <v-icon @click="removeItemFromList(item)" style="width:7px;">mdi-close</v-icon>
                </v-chip>
                <div v-tooltip.hover="$t('res_Hover_Filter')">
                    <v-menu :left="isLanguageEn" :right="!isLanguageEn" offset-x offset-y :close-on-click="true"
                        :close-on-content-click="false" :value="shown"
                        content-class="sm-full-view filter ml-2rem p-0 py-1 px-1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="btn-sm" color="white" v-bind="attrs" :ripple="false" v-on="on"
                                @click="shown = true">
                                <v-icon>mdi-filter-outline</v-icon>
                            </v-btn>
                        </template>
                        <div class="pt-4 cts-sheet">
                            <v-btn class="close-btn light-btn float-right sm-screen" icon @click="shown = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <div class="flex-1 overflow-auto px-3">
                                <h3 class="section-title m-0">{{ $t("res_MenuItems_Filter") }}</h3>

                                <div class="pt-5">
                                    <div class="mb-4">
                                        <v-label>{{ $t("res_MenuItems_ReferenceNumber") }}</v-label>
                                        <v-text-field solo v-model="filter_reference_number"
                                            :placeholder="$t('res_Label_defaultTextValue')"  @keyup.enter="applyFilters"></v-text-field>
                                    </div>
                                    <div class="mb-4">
                                        <v-label>{{ $t("res_GridHeaders_CreatedSubject") }}</v-label>
                                        <v-text-field solo v-model="filter_subject"
                                            :placeholder="$t('res_Label_defaultTextValue')"  @keyup.enter="applyFilters"></v-text-field>
                                    </div>
                                    <div class="mb-4">
                                        <v-label>{{ $t("res_Label_Category") }}</v-label>
                                        <multi-select class="light-bg add-arrow" v-model="filter_category" label="name"
                                            track-by="id" open-direction="bottom" :options="category_items"
                                            :searchable="false" :loading="loading" :internal-search="false"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                            :max-height="600" :show-no-results="false" :hide-selected="false"
                                            :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_Select')">
                                            <template slot="noOptions" slot-scope="props">
                                                {{ $t("res_Msgs_EmptySearch") }}
                                            </template>
                                        </multi-select>
                                    </div>
                                    <div class="mb-4" v-if="nodeId === 2">
                                        <v-label>{{ $t("res_Label_Purpose") }}</v-label>
                                        <multi-select class="light-bg add-arrow" v-model="filter_purpose" label="name"
                                            track-by="id" open-direction="bottom" :options="action_types"
                                            :searchable="false" :loading="loading" :internal-search="false"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                            :max-height="600" :show-no-results="false" :hide-selected="false"
                                            :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_Select')">
                                            <template slot="noOptions" slot-scope="props">
                                                {{ $t("res_Msgs_EmptySearch") }}
                                            </template>
                                        </multi-select>
                                    </div>
                                     <div class="mb-4" v-if="nodeId === 2">
                                        <v-label>{{ $t("res_Label_Status") }}</v-label>
                                        <multi-select class="light-bg add-arrow" v-model="filter_status" label="name"
                                            track-by="id" open-direction="bottom" :options="status_types"
                                            :searchable="false" :loading="loading" :internal-search="false"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                            :max-height="600" :show-no-results="false" :hide-selected="false"
                                            :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_Select')">
                                            <template slot="noOptions" slot-scope="props">
                                                {{ $t("res_Msgs_EmptySearch") }}
                                            </template>
                                        </multi-select>
                                    </div>
                                    <div class="mb-4" v-if="nodeId === 2">
                                        <v-label>{{ $t("res_GridHeaders_TransferSenderRecipient") }}</v-label>
                                        <multi-select class="light-bg add-arrow" v-model="filter_sender" label="name"
                                            track-by="id" open-direction="bottom" :options="sender_items"
                                            :searchable="true" :loading="loading" :internal-search="false"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                            :max-height="600" :show-no-results="false" :hide-selected="true"
                                            :multiple="false" ref="multiselect2" @search-change="asyncFindSender"
                                            @close="sender_items = []" :placeholder="$t('res_Label_Select')">
                                            <template slot="option" slot-scope="props">
                                                <div style="height: 50px; width: 100%; display: flex">
                                                    <div class="" style="">
                                                        <v-avatar color="#eff2f5" size="43">
                                                            {{
                                                            CapitalizeFirstLetter(props.option.name)
                                                            }}
                                                        </v-avatar>
                                                    </div>
                                                    <div class="ad__box" v-if="props.option.isUser">
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">
                                                            {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                        </p>
                                                    </div>
                                                    <div class="ad__box" v-else>
                                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                                        <p class="ad__text">
                                                            {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="noOptions" slot-scope="props">
                                                {{ $t("res_Msgs_EmptySearch") }}
                                            </template>
                                        </multi-select>
                                    </div>
                                    <div class="mb-4">
                                        <v-label>{{ $t("res_GridHeaders_Created_ReceivedDate") }}</v-label>
                                        <v-menu offset-y content-class="p-0" v-model="created_date_datePicker"
                                            :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="utils.dateFormat(filter_created_date)" :label="$t('res_Label_SelectDate')"
                                                    readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                                    :tabindex="-1" :placeholder="constants.defaultDateValue">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker :locale="selectedLang" v-model="filter_created_date"
                                                @input="created_date_datePicker = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div class="mb-4" v-if="nodeId !== 1">
                                        <v-label>{{ $t("res_GridHeaders_DueDate") }}</v-label>
                                        <v-menu content-class="p-0" offset-y v-model="due_date_datePicker"
                                            :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="utils.dateFormat(filter_due_date)" :label="$t('res_Label_SelectDate')"
                                                    readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                                    :tabindex="-1" :placeholder="constants.defaultDateValue">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker :locale="selectedLang" v-model="filter_due_date"
                                                @input="due_date_datePicker = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="form-actions m-0 mx-4 py-4">
                                <v-btn class="dgs-new-button" @click="clearFilters">{{ $t("res_ButtonText_Clear")
                                    }}</v-btn>
                                <v-btn class="dgs-new-button" @click="applyFilters">{{ $t("res_ButtonText_Apply")
                                    }}</v-btn>
                            </div>
                        </div>
                    </v-menu>
                </div>

                <v-btn v-tooltip.hover="$t('res_Hover_Refresh')" class="btn-sm" color="white" @click="refreshPageGrid()">
                    <img src="/assets/images/icons/refresh.svg" alt="" />
                </v-btn>
                <v-btn class="btn-sm" color="white" @click="exportToExcelOrPdf(1)"
                    v-tooltip="$t('res_Export_To_Excel')">
                    <v-icon class="bg-gray black--text custom-button"
                        style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon>
                </v-btn>
                <v-btn class="btn-sm" color="white" @click="exportToExcelOrPdf(2)"
                    v-tooltip="$t('res_Export_To_Pdf')">
                    <v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn v-if="constants.enableManageGridHeaders" class="btn-sm d-md-block" color="white"
                    @click="openHeadersDialog()" v-tooltip="`${$t('res_Label_ManageGridHeaders')}`">
                    <v-icon class="bg-gray custom-button">mdi-cog</v-icon>
                </v-btn>
            </div>
        </nav>

        <div class="tab-content">
            <div class="panel">
                <div class="d-flex flex-wrap gap-2">
                    <div class="cts-pane">
                        <div class="position-relative sm-margin mt-2 DocumentsList">

                            <v-data-table v-if="correspondences.length" id="ListCorrespondancesTable" :mobile-breakpoint="600"
                                :header-props="{ sortByText: $t('res_Label_SortBy') }"
                                :headers="grid_headers" v-model="selected" :items="correspondences"
                                :item-key="nodeId == 1 ? 'id' : 'transferId'" :items-per-page="pagingData.pageSize"
                                hide-default-footer class="elevation-1 empty-full-height cts-grid" :item-class="getRowClass"
                                show-select :single-select="enableSingleSelect" :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc" @dblclick:row="(event, row) => viewCorrespondence(row.item, true)"
                                @click:row="(item) => viewCorrespondence(item, false)" @item-selected="itemSelected"
                                @update:sort-by="updateSortBy" @update:sort-desc="updateSortDesc" must-sort
                                :class="selected.length !== 0 && !enableSingleSelect && !openPreviewPane ? 'bulk-actions-active' : ''">
                                <!-- bug ::select and unselect will open the full letter to be fixed -->
                                <!-- <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                                    <v-simple-checkbox :value="isSelected" @click.stop="select(!isSelected)"></v-simple-checkbox>
                                 </template>-->
                                <!--sent to structure-->
                                <template v-slot:[`item.toUserId`]="{ item }">
                                    <label class="align-center d-flex mx-2" v-if="!item.toUserId || item.lockedByUserId">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" color="#f77600">mdi-bookmark</v-icon>
                                            </template>
                                            <span class="p-3" style="color: #f77600;">{{
                                                $t("res_Label_SentToStructure") }}</span>
                                        </v-tooltip>
                                    </label>
                                </template>
                                <!--overdue-->
                                <template v-if="grid_headers.find(h => h.value === 'overdue' && h.show)" v-slot:item.overdue="{ item }">
                                    <label v-if="getOverdueText(item)" class="text-warning overdue-label d-flex align-items-center">
                                        <v-icon>{{ utils.getOverDue(item.overdue, nodeId) }}</v-icon>
                                        <span>
                                            <span v-for="(line, idx) in getOverdueText(item).split('\n')" :key="idx" class="d-block">{{ line }}</span>
                                        </span>
                                    </label>
                                </template>
                                <template v-slot:item.categoryId="{ item }">
                                    {{ getCategoryTitle(item.categoryId) }}
                                </template>
                                <template v-slot:item.status="{ item }">
                                    <div class="d-flex align-items-center h-100">
                                        <v-chip dark :color=getStatusClass(item) text-color="white">{{ item.status }}</v-chip>
                                    </div>
                                </template>
                                <template v-slot:item.purpose="{ item }">
                                    <div class="d-flex align-items-center h-100">
                                        <v-chip dark :color="getPurposeColor(item)" text-color="black">{{ item.purpose }}</v-chip>
                                    </div>
                                </template>
                                <template v-slot:item.received_on="{ item }">
                                    <div class="d-flex align-items-center h-100">
                                        {{ item.received_on }}
                                    </div>
                                </template>
                                <template v-slot:item.dispatchStatus="{ item }">
                                    <div v-if="item.dispatchStatus && item.dispatchStatus !== 0">
                                        <v-chip
                                        dark
                                        :color="getDispatchColor(item.dispatchStatusId)"
                                        text-color="white"
                                        >
                                        {{ item.dispatchStatus }}
                                        </v-chip>
                                    </div>
                                </template>
                                <!--attachment-->
                                <template v-slot:item.hasAttachment="{ item }">
                                    <v-icon>{{ getAttachment(item.hasAttachment) }}</v-icon>
                                </template>
                                <template v-slot:item.subject="{ item }">
                                    <div class="d-flex align-items-center">
                                        <span class="mdi mdi-content-copy copy-icon" v-if="item.subject" @click.stop="utils.copyToClipboard(item.subject, 'res_Msgs_SubjectCopied')" v-tooltip="$t('res_Label_CopySubject')"></span>
                                        <a class="td-text-limit">
                                            <span class="subjectCell" v-tooltip="item.subject">{{ item.subject }}</span>
                                        </a>
                                    </div>
                                </template>
                                <template v-slot:item.referenceNumber="{ item }">
                                    <div class="d-flex align-items-center">
                                        <span class="mdi mdi-content-copy copy-icon" v-if="item.referenceNumber" @click.stop="utils.copyToClipboard(item.referenceNumber, 'res_Msgs_ReferenceNumberCopied')" v-tooltip="$t('res_Label_CopyReferenceNumber')"></span>
                                        <span class="text-limit" v-tooltip="item.referenceNumber">{{ item.referenceNumber }}</span>
                                    </div>
                                </template>
                                <template v-slot:item.sender="{ item }">
                                    <span class="text-limit" v-tooltip="item.sender">{{ item.sender }}</span>
                                </template>
                                <template v-slot:item.recievedDate="{ item }">
                                    {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.recievedDate) :
                                    utils.formatDateTime(item.recievedDate) }}
                                </template>
                                <template v-slot:item.createdDate="{ item }">
                                    {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.createdDate) :
                                    utils.formatDateTime(item.createdDate) }}
                                </template>
                                <template v-slot:item.dueDate="{ item }">
                                    {{ utils.formatDateTime(item.dueDate) }}
                                </template>
                                <template v-slot:item.openedDate="{ item }">
                                    {{ utils.formatDateTime(item.openedDate) }}
                                </template>
                                <template v-slot:item.transferInstruction="{ item }">
                                    <p class='text-truncate mb-0'>
                                        {{ item.transferInstruction }}
                                    </p>
                                </template>
                                
                                <template v-slot:[`item.actions`]="{ item }">
                                    <div class="d-flex align-items-center justify-content-end gap-2" style="cursor:pointer !important" @click.stop>
                                        <div class="custom-icon-wrapper d-flex align-items-center justify-content-center"
                                            v-if="nodeId != 8 && (item.toUserId == null || item.lockedByUserId)"
                                            v-tooltip="$t('res_Label_SentToStructure')">
                                            <v-icon class="flex-shrink-0" color="#f77600">mdi-account-group-outline</v-icon>
                                        </div>
                                        <div class="custom-icon-wrapper d-flex align-items-center justify-content-center"
                                            v-tooltip="$t('res_ButtonText_VisualTracking')">
                                            <div class="d-flex align-items-center justify-content-center" @click="openVisualTrackingFromInbox(item.documentId)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                                    viewBox="0 0 24 24">
                                                    <path fill="#000000"
                                                        d="M19 20.5q-.898 0-1.586-.562t-.855-1.438H11q-1.458 0-2.479-1.021T7.5 15t1.021-2.479T11 11.5h2q1.031 0 1.766-.735q.734-.736.734-1.769t-.734-1.764T13 6.5H7.44q-.17.875-.856 1.438T5 8.5q-1.042 0-1.77-.728q-.73-.729-.73-1.77t.73-1.771T5 3.5q.898 0 1.584.563q.685.562.857 1.437H13q1.458 0 2.479 1.021T16.5 9t-1.021 2.479T13 12.5h-2q-1.031 0-1.766.736q-.734.735-.734 1.768t.735 1.764q.734.732 1.765.732h5.56q.17-.875.856-1.437T19 15.5q1.042 0 1.77.729q.73.728.73 1.769t-.73 1.771T19 20.5M5 7.5q.617 0 1.059-.441Q6.5 6.617 6.5 6t-.441-1.059Q5.617 4.5 5 4.5t-1.059.441Q3.5 5.383 3.5 6t.441 1.059Q4.383 7.5 5 7.5" />
                                                </svg>

                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-data-table>

                            <div v-else class="cts-empty">
                                <img src="/assets/images/empty-inbox.svg" alt="" />
                                <p class="m-0">{{ $t("res_Msgs_GetAllCaughtUp") }}</p>
                                <p class="m-0">{{ $t("res_Msgs_NoNewItem") }}</p>
                            </div>
                        
                            <div class="d-flex align-items-center w-100 margin-top-s">
                                <Pagination :totalCount="inboxes[selected_index].count"
                                    :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex"
                                    @pageIndexChanged="pageIndexChanged" :showPageSize="true" :showMargin="false">
                                </Pagination>
                                <div class="d-flex justify-content-center align-items-center bulk-action-bar"
                                v-if="selected.length >= 2 && !enableSingleSelect && !openPreviewPane">
                                <div class="d-flex gap-75 bulk-actions-container">
                                    <v-btn class="primary bulk-action-btn" v-if="shouldShowBulkButton('Archive')"
                                        @click="openCompleteDocumentDialog()">
                                        {{ $t("res_ButtonText_BulkArchive") }}
                                    </v-btn>
                                    <v-btn class="primary bulk-action-btn" @click="downloadCorrespondences(false)">
                                        {{ $t("res_ButtonText_Download") }}
                                    </v-btn>
                                    <v-btn class="primary bulk-action-btn" @click="downloadCorrespondences(true)">
                                        {{ $t("res_ButtonText_DownloadWithAttachments") }}
                                    </v-btn>
                                    <v-btn class="primary bulk-action-btn" @click="DownloadAttachmentsAsZip()">
                                        {{ $t("res_ButtonText_DownloadAttachmentsAsZip") }}
                                    </v-btn>
                                    <v-btn class="primary bulk-action-btn" v-if="shouldShowBulkButton('BulkTransfer')" @click="bulkTransfers()">
                                        {{ $t("res_ButtonText_BulkTransfer") }}
                                    </v-btn>
                                    <!--<v-btn v-if="nodeId == 1" class="primary bulk-action-btn" @click="deleteDrafts()">
                                        {{ $t("res_ButtonText_Delete") }}
                                    </v-btn>-->
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="cts-pane py-2" v-if="openPreviewPane">
                        <div
                            style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden;height:95%">
                            <div>
                                <v-btn class="close-btn d-block bg-white close-viewer " icon @click="closePreview()">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>

                            <!--viewer section-->
                            <div class=" position-relative viewer-container scrollable-container"
                                style="height: calc(100vh - 150px - 1rem); overflow-y: hidden;">
                                <div v-if="empty_viewer" class="empty-viewer"
                                    style="border-radius: 12px; height: calc(100vh - 176px);">
                                    <img src="/assets/images/icons/template.svg" />
                                    <img src="/assets/images/icons/no_preview.svg" />
                                    <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                                </div>
                                <div v-if="!empty_viewer" id="viewer_template" class="h-100"
                                    style="border-radius: 12px;">
                                    <iframe id="viewerFrame" :src="viewerFrame" class="w-100"></iframe>
                                </div>
                            </div>

                            <!--action buttons-->
                            <div class="d-flex justify-content-between align-items-center bottom-action-bar m-0 gap-2 w-100"
                                id="rowContainer">

                                <TransferNotesIcon v-if="showPreviewInstruction" ref="transferNotesIcon"
                                    :isSecretNote="isSecretNote" :toUserId="toUserId" :loginUserId="loginUserId">
                                </TransferNotesIcon>

                                <div class="d-flex gap-2 ml-md-auto">

                                    <v-btn color="light-blue" @click="viewCorrespondence(selectedItem.item, true)" id="btn_fullView">{{
                                        $t("res_ButtonText_Full_View")}}</v-btn>
                                    <div v-for="(item, index) in toolbarButtons" v-bind:key="index">
                                        <v-btn v-if="!item.btnText.includes('Reject')" :class="item.btnClass"
                                            @click="item.btnClick" max-width="149">
                                            {{ $t(`${item.btnText}`) }}
                                            <v-icon v-if="item.btnIcon" class="custom-icon">{{ item.btnIcon }}</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                                <v-menu content-class="viewer-button align-bottom-left" v-if="selectedItem.item.isRegistered"
                                 top :offset-y="offset"
                                    :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" class="light-blue more-btn">
                                            <span>{{ $t("res_MenuItems_MoreActions") }}</span>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <div v-for="(item, index) in moreActionButtons" v-bind:key="index">
                                            <v-list-item @click="item.btnClick">{{ $t(`${item.btnText}`)
                                                }}</v-list-item>
                                        </div>


                                        <v-list-item @click="openVisualTracking(true)"
                                            v-if="this.nodeId != 4 && utils.ActionsPermission('VisualTracking', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_ButtonText_VisualTracking") }}</v-list-item>
                                        <v-list-item @click="cancelFollowup()"
                                            v-if="utils.ActionsPermission('CancelFollowup', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{
                                            $t("res_ButtonText_CancelFollow_Up") }}</v-list-item>
                                        <v-list-item @click="openSigningHistory(true)"
                                            v-if="utils.ActionsPermission('SigningHistory', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_DialogTitle_SigningHistory") }}</v-list-item>
                                        <v-list-item @click="openDeliveryNote()"
                                            v-if="utils.ActionsPermission('GenerateDeliveryNote', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{
                                            $t("res_Label_GenerateDeliveryNote") }}</v-list-item>
                                        <v-list-item @click="CreateOutgoing()"
                                            v-if="utils.ActionsPermission('CreateOutgoing', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_ButtonText_Outgoing") }}</v-list-item>
                                        <!-- <v-list-item @click="reminderEmailDialog = true"
                                            v-if="utils.ActionsPermission('EmailReminder', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_ButtonText_Reminder") }}</v-list-item> -->
                                        <v-list-item @click="resetDocument()"
                                            v-if="hasEditSignedPermissionRecord && utils.ActionsPermission('ResetDocument', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_Tooltip_ResetDocument") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Send Back')"
                                            v-if="utils.ActionsPermission('SendBack', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_ButtonText_SendBack") }}</v-list-item>

                                        <v-list-item @click="cancelCorrespondence(selectedItem.item.id)"
                                            v-if="utils.ActionsPermission('CancelDocument', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{
                                            $t("res_ButtonText_Cancel") }}</v-list-item>
                                        <v-list-item @click="downloadCorrespondences(false)">{{
                                            $t("res_ButtonText_Download") }}</v-list-item>
                                        <v-list-item @click="downloadCorrespondences(true)">{{
                                            $t("res_ButtonText_DownloadWithAttachments") }}</v-list-item>
                                        <v-list-item @click="DownloadAttachmentsAsZip()">{{
                                            $t("res_ButtonText_DownloadAttachmentsAsZip") }}</v-list-item>

                                        <v-list-item v-if="utils.ActionsPermission('EmailDispatchCorrespondence', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)"
                                            @click="sendCorrespondence(true)">{{
                                            $t("res_Label_EmailDispatch") }}</v-list-item>

                                        <!-- <v-menu content-class="viewer-button align-bottom-left2" v-if="isSendLetterEnabled" :left="isLanguageEn" :right="!isLanguageEn" top offset-x offset-y>
                                        <template v-slot:activator="{ on, attrs }" v-if="nodeId != 1">
                                            <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">{{
                                                $t("res_MenuItems_SendBy") }}
                                                <v-icon>mdi-chevron-down</v-icon>
                                            </v-list-item>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="sendCorrespondence(false)">{{ $t("res_MenuItems_Email") }}</v-list-item>
                                        </v-list>
                                    </v-menu> -->
                                    </v-list>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="correspondenceDialog" :key="correspondenceDialog"
            content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen
            :persistent="true">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView :documentId="documentId" :transferId="transferId" :viewMode="viewMode"
                :delegationId="delegationId" :toEmail="toEmail"
                :emailCC="emailCC" :closeDialogEvent="closeCorrespondenceDialog"
                :createReplyDocumentEvent="CreateReplyDocument" :openedFromNodeId="nodeId"/>
        </v-dialog>

        <v-dialog v-model="gridHeadersDilaog" max-width="600" class="bg-primary" scrollable :persistent="true">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0"><span>{{ $t("res_Label_ManageGridHeaders") }}</span></v-card-title>
                    <v-spacer></v-spacer>
                    <div class="flex-r-3" style="width:90px">
                        <v-btn class="close-btn light-btn"
                            :style="`${(dragEnabled ? 'background-color:#024976 !important' : '')}`" icon dark
                            @click="dragEnabled = !dragEnabled">
                            <i class="fas fa-sync" :style="`${(dragEnabled ? 'color:white !important' : '')}`"></i>
                        </v-btn>
                        <v-btn class="close-btn light-btn" icon dark @click="closeHeadersDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <Container @drop="onDrop($event)" :get-child-payload="getChildPayload2" class="list-box"
                                style="min-height: 300px; margin-bottom: 5px">
                                <Draggable v-for="(item, index) in selectedItemGrid" :key="item.id"
                                    v-show="dragEnabled">
                                    <v-row align="center" style="cursor: move;"
                                        v-if="!(nodeId === 8 && item.value === 'purpose')"
                                        @mousedown="getChildPayload2({ index, item })">
                                        <v-col cols="3 m-auto">
                                            <v-icon style="cursor:pointer;font-size:18px"
                                                class="mb-1">mdi-dots-vertical</v-icon>
                                            <label class="mb-0">{{ item.text }}</label>
                                        </v-col>
                                        <v-col cols="4 m-auto">
                                            <v-text-field :id="`input-field-${index}`" v-model="item.width" @input="CheckFullWidthForInputs(index,item,`input-field-${index}`)" type="number"  class="mt-2" solo>
                                                <template v-slot:append>
                                                    <span>%</span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="4 m-auto">
                                            <v-checkbox :id="`checkbox-field-${index}`"
                                                :label='$t("res_ButtonText_Show")'
                                                @change="CheckFullWidthForCheckboxes(index,item,`checkbox-field-${index}`)"
                                                v-model="item.show" solo></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </Draggable>

                                <div v-if="!dragEnabled">
                                    <div v-for="(item, index) in selectedItemGrid" :key="item.id">
                                        <v-row align="center" style="cursor: default;"
                                            v-if="!(nodeId === 8 && item.value === 'purpose')"
                                            @mousedown="getChildPayload2({ index, item })">
                                            <v-col cols="3 m-auto">
                                                <label class="mb-0">{{ item.text }}</label>
                                            </v-col>
                                            <v-col cols="4 m-auto">
                                                <v-text-field :id="`input-field-${index}`" v-model="item.width" @input="CheckFullWidthForInputs(index,item,`input-field-${index}`)" type="number"  class="mt-2" solo>
                                                    <template v-slot:append>
                                                        <span>%</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="4 m-auto">
                                                <v-checkbox :id="`checkbox-field-${index}`"
                                                    :label='$t("res_ButtonText_Show")'
                                                    @change="CheckFullWidthForCheckboxes(index,item,`checkbox-field-${index}`)"
                                                    v-model="item.show" solo></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </Container>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions class="d-flex justify-space-between" style="position: sticky; bottom: 0; background-color: white;">
                    <div class="d-flex align-center">
                        <v-chip 
                            :color="getTotalWidthStatus().color" 
                            :outlined="getTotalWidthStatus().type !== 'success'"
                            small
                            class="mr-2">
                            <v-icon left small :color="getTotalWidthStatus().color">
                                {{ getTotalWidthStatus().type === 'success' ? 'mdi-check-circle' : 
                                   getTotalWidthStatus().type === 'warning' ? 'mdi-alert-circle' : 'mdi-close-circle' }}
                            </v-icon>
                            {{ $t("res_Label_TotalWidth") }}: {{ getTotalActiveWidth() }}%
                        </v-chip>
                    </div>
                    <div class="d-flex gap-2">
                        <v-btn class="light-blue" @click="closeHeadersDialog()" style="min-width: 100px !important;">{{
                            $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn class="primary" style="min-width: 100px !important;" @click="saveGrid()">{{
                            $t("res_ButtonText_Continue") }}</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="transferFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ transferFormHeader }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="closeTransferFormDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <TransferForm v-if="transferFormDialog" :canSignWithoutPinCode="canSignWithoutPinCode" 
                    :isDelegatedDocumentTransferProp="this.isDelegatedDocument()"
                    :documentId="documentId" :disableAdvancedTransfer="disableAdvancedTransfer"
                    :disableRecipient="recipientDisabled" :purpose="purpose" :sign="signForm" :transferId="transferId"
                    :transferCC="transferCC" :transferTo="transferTo" :propertyBag="propertyBag"
                    :transferToMulti="transferToMulti" :rejected="rejected" :successMessage="transferSuccessMessage"
                    :forwardCC="forwardCC" :transferFormType="transferFormType" :delegationId="delegationId"
                    :categoryId="selectedItem.item.categoryId"
                    :checkForAttachmentsUploadMultiApproval="checkForAttachmentsUploadMultiApproval"
                    :clientVersionId="constants.client_version_Id" :transferFormDialog="transferFormDialog"
                    @closeTransformDialog="closeTransferFormDialog" :statusId="selectedItem.item.statusId"
                    @cancelCorrespondenceDocument="transferFormDialog = false"
                    :noteIsMandatory="sentBack && constants.client_version_Id == 'MOFA'" />
            </v-card>
        </v-dialog>

        <v-dialog v-model="deliveryNoteDialog" content-class="small-dialog" width="650" height="1350">
            <v-card>
                <v-card-title>{{ $t('res_Label_DeliveryNote') }}</v-card-title>
                <div style="overflow: hidden">
                    <DeliveryNoteConfiguration :documentId="documentId" :referenceNumber="referenceNumber"
                        :deliveryNoteDialog="deliveryNoteDialog" @closeDeliveryNote="deliveryNoteDialog = false" />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="signingHistoryDialog"
            content-class="dialog with-fixed-actions bg-white  justify-content-center w-100 w-md-50" fullscreen
            scrollable>
            <v-card class="bg-white">
                <v-toolbar class="bg-white">
                    <v-card-title style="line-height: 28px">
                        {{ $t("res_DialogTitle_SigningHistory") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="signingHistoryDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="border-top p-0 d-flex">
                    <SigningHistory :documentId="selectedDocumentId"></SigningHistory>
                </v-card-text>
                <v-card-actions class="d-flex justify-content-end" style="background-color:  #E7EBEF;">
                    <v-btn class="dgs-new-button-inner" style="height: 48px" @click="openVisualTracking()">
                        <img class="rtl-flip" width="26px" src="/assets/images/icons/tracking.svg" />{{
                        $t("res_ButtonText_Tracking") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="visualTrackingDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
            width="100%" fullscreen>
            <div class="dialog-header">
                <!-- <v-icon class="back-btn">mdi-chevron-left</v-icon> -->
                <v-btn class="close-btn light-btn tracker-close" icon dark @click="visualTrackingDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-body h-100">
                <iframe id="trackingFrame" :src="trackingFrameSrc"
                    style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
            </div>
        </v-dialog>

        <v-dialog v-model="notifyEmailDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_MenuItems_Notify") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="notifyEmailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <notify-email v-on:closeDialog="closeNotifyEmail()" :isSent="nodeId == 6 ? true : false"
                    :documentId="selectedDocumentId" :transferId="selectedTranferId" :subject="notifySubject" :toUserId="toUserId" :key="notifyEmailKey"
                    :dialogModelShow="true">
                </notify-email>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emailDispatchDocumentDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen 
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_Label_EmailDispatch") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="closeEmailDispatchDocumentDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <EmailDispatchDocumentForm :documentSubject="selectedItem.item.subject" :documentId="selectedDocumentId" :referenceNumber="selectedItem.item.referenceNumber"
                    :dialogModelShow="emailDispatchDocumentDialog" :withAttachments="withAttachments" :nodeId="nodeId" :key="dispatchByEmailComponentKey"
                    v-on:closeDialog="closeEmailDispatchDocumentDialog()"></EmailDispatchDocumentForm>
            </v-card>
        </v-dialog>

        <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
            <v-card>
                <v-card-title class="text-h5 blue lighten-2">
                    {{ $t("res_CardHeaders_Sign") }}
                </v-card-title>
                <div style="overflow: hidden">
                    <Sign :canSignWithoutPinCode="canSignWithoutPinCode" :propertyBag="propertyBag" :isDelegatedDocumentSignProp="this.isDelegatedDocument()"
                        :dialogModelShow="signFormDialog" :purpose="purpose"
                        @refreshAfterClosingSignDialog="refreshAfterClosingSignDialog"
                        @closeSignFormDialog="closeSignFormDialog" />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650"
            height="750">
            <v-card>
                <v-card-title class="text-h5 blue lighten-2">
                    {{ $t("res_CardHeaders_Sign") }}
                </v-card-title>
                <div style="overflow: hidden">
                    <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                        :allowUAEPASSSignature="allowUAEPASSSignature" :allowESignature="allowESignature"
                        @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                        @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                        @closeSignFormDialog="closeSignFormDialog"
                        :isUAEPassEnabledForTemplate="selectedItem.item.isUAEPassEnabled"
                        :isEsealEnabledForTemplate="selectedItem.item.isEsealEnabled"
                        @refreshAfterClosingSignMethodSelect="refreshAfterClosingSignMethodSelect" />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="completeDocumentDialog" content-class="small-dialog" width="500" height="350">
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_CompleteNotes") }}
                </v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Msgs_EnterNotes") }} *</label>
                    <v-textarea v-model="completeDocument_noteText" solo></v-textarea>
                    <template v-if="showClassificationField == true">
                        <div class="mt-2">
                            <label>{{ $t("res_label_ClassificationPlan")}} *</label>
                            <FilingClassificationPlanSelector :mode="2" :selectedClassificationPlan="null"
                                @ClassificationPlanSelectChanged="classificationPlanSelectChanged">
                            </FilingClassificationPlanSelector>
                        </div>
                    </template>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" width="100"
                        @click="completeDocument_noteText = ''; completeDocumentDialog = false;">
                        {{
                        $t("res_ButtonText_Cancel")
                        }}
                    </v-btn>
                    <v-btn color="primary" width="100" @click="completeDocument()">
                        {{
                        $t("res_ButtonText_Continue")
                        }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openOwnerDialog" content-class="small-dialog" width="500" height="350" persistent>
            <v-card>
                <v-card-title>
                    {{ $t("res_Msgs_CorrespondenceOwner") }}
                </v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_DialogTitle_CorrespondenceOwner") }}</label>
                    <label class="d-block mt-4" v-if="ownerDialogDescription()"
                        v-html="ownerDialogDescription()"></label>
                </div>
                <v-card-actions class="sticky-actions">
                    <v-spacer></v-spacer>

                    <v-btn color="primary" width="100" @click="ownerDialogConfirmed()">{{
                        $t("res_ButtonText_Yes")}}</v-btn>
                    <v-btn color="light-blue" width="100" @click="ownerDialogDeclined()">{{$t("res_ButtonText_No")
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="hideCorrespondenceDialog" content-class="small-dialog" width="400px">
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_Hide") }}
                </v-card-title>
                <div class="card-body">
                    <div class="col-sm-12">
                        <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                        <v-menu content-class="p-0" v-model="hideToDateMenu" :close-on-content-click="false"
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="hideToDate" :label="$t('res_Label_SelectDate')" readonly v-bind="attrs" v-on="on" solo
                                    append-icon="mdi-calendar" :tabindex="-1">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :locale="selectedLang" v-model="hideToDate" @input="hideToDateMenu = false"
                                :min="nextDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="hideCorrespondenceDialog = false">
                        {{ $t("res_ButtonText_Cancel") }}
                    </v-btn>
                    <v-btn color="primary" @click="SaveForLater">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-dialog v-model="bulkTransferFormDialog" content-class="dialog with-fixed-actions bg-white" :key="bulkTransferDialogKey" fullscreen scrollable :persistent="true">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_ButtonText_BulkTransfer") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="bulkTransferFormDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
                <v-banner single-line outlined style="background-color: #f9f9f9;">
                    <v-icon slot="icon" color="warning" size="30">mdi-alert</v-icon>
                    <span style="font-size: 1rem;">{{ $t("res_Msgs_BulkTransferWarningMessage") }}</span>
                </v-banner>
                <BulkTransferForm  v-if="bulkTransferFormDialog" @closeBulkTransferForm="bulkTransferFormDialog=false" @closeBulkTransferDialog="closeBulkTransferForm" 
                    :selectedItems="selected"
                    :purpose_items="action_types">
                </BulkTransferForm>
            </v-card>
        </v-dialog>

        <v-dialog fullscreen content-class="fullscreen-dialog" v-model="visualTrackingDialogNew">
            <TrackingView2 :documentId="visualTrackingDialogNew_selectedDocumentId"
                :closeDialogFunc="closeNewTrackerDialog" />
        </v-dialog>

    </div>
</template>
<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import Tabs from './Tabs.vue'
import MultiSelect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import { getTransferPurposes } from '@/store/modules/lookups.js'
import CreateDocumentView from '@/views/CreateDocumentView.vue'
import { defaultGet, defaultPost } from '@/assets/js/common.js'
import TransferForm from '@/components/TransferForm.vue'
import SigningHistory from '@/components/SigningHistory.vue'
import TrackingTree from '@/components/TrackingTree.vue'
import * as utils from '@/assets/js/common.js'
import encryptedMethods from '@/utils/encryptedMethods'
import NotifyEmail from '@/components/NotifyEmail.vue'
import EmailDispatchDocumentForm from '@/components/EmailDispatchDocumentForm.vue'
import DeliveryNoteConfiguration from './DeliveryNoteConfiguration.vue'
import Sign from '@/components/Sign.vue'
import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
import Pagination from '@/components/Pagination.vue'
import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
import MessagesUtil from '@/utils/messagesUtil' 
import TrackingView2 from "@/views/TrackingView2.vue";
import { Container, Draggable } from 'vue-smooth-dnd'
import FilingClassificationPlanSelector from '@/components/FilingClassificationPlanSelector.vue'
import * as docActions from '@/assets/js/documentActions.js'
import BulkTransferForm from '@/components/BulkTransferForm.vue'

export default {
    name: 'ListCorrespondences',
    components: { Container, Draggable  , TrackingView2, Tabs, MultiSelect, CreateDocumentView, TransferForm, SigningHistory, TrackingTree, 
        NotifyEmail, EmailDispatchDocumentForm, DeliveryNoteConfiguration, Sign, SignSelectSignMethod, Pagination, TransferNotesIcon, 
        FilingClassificationPlanSelector, BulkTransferForm
    },
    props:
    {
        nodeId: { type: Number, default: 0 },
        forUserOnly: {type:Boolean, default:false},
        forStructureOnly: {type:Boolean, default:false},
    },
    data() {
        return {
            bulkTransferFormDialog: false,
            bulkTransferDialogKey: 0,
            dispatchByEmailComponentKey: 0,
            selectedLang: 'en',
            dragEnabled: false,
            filterList: [],
            visualTrackingDialogNew: false,
            visualTrackingDialogNew_selectedDocumentId: '0',
            rejected: false,
            sentBack: false,
            forwardCC: false,
            transferSuccessMessage: '',
            propertyBag: {},
            signFormDialog: false,
            selectSignMethodFormDialog: false,
            recipientDisabled: false,
            isLanguageEn: true,
            shown: false,
            offset: true,
            loading: false,
            sender_items: [],
            action_types: getTransferPurposes(),
            purposes: getTransferPurposes(),
            status_types: [],
            category_items: [],
            filter_category: '',
            filter_reference_number: '',
            filter_created_date: '',
            filter_subject: '',
            filter_due_date: '',
            filter_sender: null,
            filter_purpose: null,
            filter_status: null,
            due_date_datePicker: false,
            created_date_datePicker: false,
            display_alert: false,
            messagesUtil: MessagesUtil,
            isExport: false,
            exportType: 0,
            sortBy: 'received_on',
            sortDesc: true,
            correspondences: [],
            selectedItem: { item: { isEsealEnabled: false, isUAEPassEnabled: false }, value: false },
            selected: [],
           
            grid_headers: [
                { text: '', value: 'data-table-select' },
                { text: 'Subject', value: 'subject', sortable: false ,show:false },
                { text: '', value: 'Overdue', sortable: false ,show:false },
                { text: 'Due date', value: 'dueDate', sortable: true ,show:false },
                { text: 'Forwarded from', value: 'fromUser', sortable: false ,show:false },
                { text: 'Sender', value: 'sender', sortable: false ,show:false },
                { text: 'Privacy', value: 'privacy', sortable: false,show:false },
                { text: 'Action types', value: 'purpose', sortable: false,show:false },
                { text: 'Status', value: 'status', sortable: false ,show:false},
                { text: 'Received on', value: 'received_on', sortable: true ,show:false},
                { text: '', value: 'flag', sortable: false,show:false },
                { text: '', value: 'attachment', sortable: false ,show:false},
            ],
            selectedItemGrid: [],
            loadedItemGrid: [],
            openPreviewPane: false,
            viewerFrame: '',
            empty_viewer: true,

            inboxes: [{ id: 1, name: 'My Inbox', inboxId: 1, delegationId: 0, count: 0 }],
            selected_node: {},
            selected_index: 0,
            delegationId: null,

            correspondenceDialog: false,
            isFullView: false,
            documentId: '0',
            transferId: '0',
            viewMode: 'readonly',

            transferCC: [],
            transferTo: null,
            transferToMulti: [],
            transferFormHeader: 'Transfer',
            transferFormDialog: false,
            purpose: {},
            signForm: false,
            checkForAttachmentsUploadMultiApproval: false,
            disableAdvancedTransfer:true,

            selectedDocumentId: '0',
            selectedTranferId: '0',
            trackingFrameSrc: '',
            signingHistoryDialog: false,
            visualTrackingDialog: false,
            notifyEmailDialog: false,
            emailDispatchDocumentDialog: false,
            //reminderEmailDialog: false,
            viaEmailEntities: [],
            failedEntities: [],
            withAttachments: false,
            referenceNumber: "",
            deliveryNoteDialog: false,
            notifySubject: "",
            utils: utils,
            constants: constants,

            pagingData: {
                pageSize: 20,
                pageIndex: 0
            },
            completeDocumentDialog: false,
            completeDocument_noteText: '',
            canSignDocument: false,
            showActionsBtns: false,
            hideCorrespondenceDialog: false,
            hideToDate: '',
            hideToDateMenu: false,
            reminderToDate: '',
            remindToDateMenu: false,
            nowDate: new Date().toISOString().slice(0, 10),
            fromEmail: [],
            toolbarButtons: [],
            moreActionButtons: [],
            isSecretNote: false,
            toUserId: 0,
            toEmail: "",
            emailCC: "",
            loginUserId: 0,
            loginStructureId: 0,
            gridHeadersDilaog: false,
            itemToBeUpdated:{},
            showClassificationField: false,
            classificationPlanId: 0,
            openOwnerDialog: false,
            showMarkLetterAsDispatched: false,
            showUndoMarkLetterAsDispatched: false,
            canSignWithoutPinCode: false,
            enableSignWithOutPinCodeFeature: false,
            transferFormType: '',
            exportListName:
            [
                {nodeId:1,  name:"Draft"},
                {nodeId:2,  name:"Inbox"},
                {nodeId:4,  name:"Via Email"},
                {nodeId:6,  name:"Sent"},
                {nodeId:7,  name:"Saved For Later"},
                {nodeId:9,  name:"FollowUp"},
                {nodeId:8,  name:"Archive"},
                {nodeId:10, name:"CCed"},
                {nodeId:11, name:"Advanced Search"},
            ],
            showPreviewInstruction: true,
            allowESignature: false,
            allowUAEPASSSignature: false,
            hasEditSignedPermissionRecord: false,
            notifyEmailKey: 0,
        };
    },
    mounted() 
    {
        this.status_types = window.statuses
        this.enableSignWithOutPinCodeFeature = window.enableSignWithOutPinCodeFeature

        this.selectedLang =  localStorage.getItem('lang');
        var user = JSON.parse(sessionStorage.getItem("user"));
        this.fromEmail = user.profile.Email;
        this.loginUserId = user.profile.Id;
        this.loginStructureId = user.profile.StructureId;

        this.transferFormHeader = window.translate("res_DialogTitle_Transfer")
        this.inboxes = [{ id: 1, name: window.translate("res_TabsName_Inbox"), inboxId: 1, delegationId: 0, count: 0 }]
        this.grid_headers = [
            { text: '', value: 'data-table-select' },
            { text: window.translate("res_GridHeaders_CreatedSubject"), value: 'subject', sortable: false },
            { text: window.translate("res_GridHeaders_DueDate"), value: 'dueDate', sortable: true },
            { text: window.translate("res_GridHeaders_ForwaredFrom"), value: 'senderUser', sortable: false },
            { text: window.translate("res_Label_Sender"), value: 'sender', sortable: false },
            { text: window.translate("res_Label_Privacy"), value: 'privacy', sortable: false },
            { text: window.translate("res_GridHeaders_ActionType"), value: 'purpose', sortable: false },
            { text: window.translate("res_Label_Status"), value: 'status', sortable: false },
            { text: window.translate("res_Label_RecievedOn"), value: 'received_on', sortable: true },
            { text: window.translate("res_Label_Overdue"), value: 'overdue', sortable: false },
            { text: '', value: 'flag', sortable: false },
            { text: '', value: 'attachment', sortable: false },
        ]
     

        this.openDefaultSignerMethod();
        this.initBox();
        
        this.openCorrespondenceFromLink();
        this.openCorrespondenceFromEmailLink();
        this.openOnePortalCorrespondence();
    },
    methods:
    {
        async getEditSignedPermissionRecordFlag()
        {
            if (this.documentId == null || this.documentId == undefined || this.documentId == 0)
            {
                this.hasEditSignedPermissionRecord = false;
                return;
            }

            axios.get(constants.baseApiUrl + 'Document/hasEditSignedPermissionRecords?documentId=' +
                this.documentId + '&transferId=' + this.transferId, { headers: constants.headers })
                .then(response => {
                    this.hasEditSignedPermissionRecord = (response != null && response.data === true)
                }).catch(err => console.warn(err))
        },
        closeBulkTransferForm()
        {
            this.bulkTransferFormDialog = false;
            this.getItemsForSelectedInbox(true)
            this.closeDialog();
        },
        openDefaultSignerMethod()
        {
            axios.post(constants.baseApiUrl + 'StructureUser/GetDefaultSignerMethod', null)
                .then(response => 
                {
                    if (response.data != null)
                    {
                        this.allowESignature = response.data.allowESignature,
                        this.allowUAEPASSSignature = response.data.allowUAEPASSSignature
                    }
                }).catch(err => console.warn(err))
                .finally(()=> window.hideLoading())
        },
        closeNotifyEmail()
        {
            this.dialogModelShow = false;
            this.notifyEmailDialog = false;
        },
        isDelegatedDocument()
        {
            if( this.toUserId && this.loginUserId && this.toUserId !== this.loginUserId )
            {
                if(this.toUserId != this.loginUserId)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else
            {
                return false;
            }
        },   
        closeEmailDispatchDocumentDialog()
        {
            this.emailDispatchDocumentDialog = false;
        },
        async openHeadersDialog()
        {            
            this.selectedItemGrid = this.loadedItemGrid.map(item => ({ ...item }));
            this.gridHeadersDilaog = true;
        },
        closeHeadersDialog()
        {
            this.GetAllGrid();
            this.gridHeadersDilaog = false;
        },
        openCorrespondenceFromLink()
        {
            if (this.$route.params.name == undefined || this.$route.params.name == null) return;

            axios.get(constants.baseApiUrl + 'Transfer/GetTransferDetailsFromEncryptedId?encryptedId=' + this.$route.params.name)
            .then(res =>
            {
                if (res == undefined || res.data == undefined || res.data.item1 != true) return;

                var ids = res.data.item2.split('-');

                // || 0 matters: a missing part parses to NaN, and NaN passes a <= 0 guard
                this.openCorrespondenceById(parseInt(ids[0]) || 0, parseInt(ids[1]) || 0, parseInt(ids[2]) || 0);
            })
            .catch(err => console.warn(err))
        },
        openCorrespondenceFromEmailLink()
        {
            if (utils.CheckIfNullOrEmpty(sessionStorage.getItem("encTransferId")))
                return;

            var landingNodeId = parseInt(sessionStorage.getItem("encNodeId")) || 2;

            if (this.nodeId != landingNodeId)
            {
                if (this.nodeId == 2 || this.nodeId == 10)
                    this.$router.push(landingNodeId == 10 ? '/cced' : '/inbox').catch(() => { });

                return;
            }

            var encDocId = sessionStorage.getItem("encDocId");
            var transferId = parseInt(encryptedMethods.decryptParam(sessionStorage.getItem("encTransferId"))) || 0;
            var documentId = utils.CheckIfNullOrEmpty(encDocId) ? 0 : parseInt(encryptedMethods.decryptParam(encDocId)) || 0;

            // single use: a refresh must not replay a link that was already consumed
            sessionStorage.removeItem("encTransferId");
            sessionStorage.removeItem("encDocId");
            sessionStorage.removeItem("encToUserId");
            sessionStorage.removeItem("encToStructureId");
            sessionStorage.removeItem("encNodeId");

            this.openCorrespondenceById(documentId, transferId, 0);
        },
        openOnePortalCorrespondence()
        {
            if ((this.nodeId != 2 && this.nodeId != 9) || this.forUserOnly || this.forStructureOnly)
                return;

            if (utils.CheckIfNullOrEmpty(sessionStorage.getItem("op_transferId")))
                return;

            var transferId = parseInt(sessionStorage.getItem("op_transferId")) || 0;
            var documentId = parseInt(sessionStorage.getItem("op_documentId")) || 0;
            var delegationId = parseInt(sessionStorage.getItem("op_delegationId")) || 0;

            // the hand-off is single use: a refresh must not replay one that was already consumed
            sessionStorage.removeItem("op_transferId");
            sessionStorage.removeItem("op_documentId");
            sessionStorage.removeItem("op_delegationId");
            sessionStorage.removeItem("op_nodeId");

            this.openCorrespondenceById(documentId, transferId, delegationId);
        },
        openCorrespondenceById(documentId, transferId, delegationId, attempt = 0)
        {
            if (transferId <= 0 || documentId <= 0)
                return;

            var node = delegationId > 0 ? this.inboxes.find(x => x.delegationId == delegationId) : this.inboxes[0];

            // initBox pushes the delegation tabs only once the delegations lookup resolves, so a
            // delegated letter has to wait here until its own tab shows up
            if (node == undefined)
            {
                if (attempt < 50)
                    setTimeout(() => this.openCorrespondenceById(documentId, transferId, delegationId, attempt + 1), 100);
                else
                    this.correspondenceNotAvailable();

                return;
            }

            if (this.selected_node.delegationId != node.delegationId)
                this.nodeClicked(node);

            var request = {
                NodeId: this.nodeId,
                DelegationId: delegationId,
                PageIndex: 0,
                PageSize: this.pagingData.pageSize,
                SortBy: this.sortBy,
                SortDir: (this.sortDesc ? 'desc' : 'asc'),
                ForUserOnly: this.forUserOnly,
                ForStructureOnly: this.forStructureOnly,
                DocumentIds: documentId.toString(),
            }

            window.showLoading();
            axios.post(constants.baseApiUrl + 'Transfer/List', request)
                .then((res) =>
                {
                    if (!res || !Array.isArray(res.data))
                    {
                        window.showAlert('res_Msgs_ErrorOccured', 'error');
                        return;
                    }

                    var item = res.data.find(x => x.transferId == transferId);

                    if (!item)
                    {
                        this.correspondenceNotAvailable();
                        return;
                    }

                    this.viewCorrespondence(item, true);
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading());
        },
        correspondenceNotAvailable()
        {
            window.showAlert(this.nodeId == 9 ? 'res_Msgs_CorrespondenceNotInFollowUp' : 'res_Msgs_CorrespondenceNotInInbox', 'warning');
        },
        async fetchCanSignWithoutPin()
        {
            try 
            {
                var response = await axios.get(constants.baseApiUrl + 'User/GetCanSignWithoutPinCode');
                return response.data && this.enableSignWithOutPinCodeFeature;
            } 
            catch (error) 
            {
                console.log(error);
                return false;
            }
        },
        blockInvalidChars(e) {
            // Block: . + - and e (for scientific notation)
            if (['.', '+', '-', 'e', 'E'].includes(e.key)) {
                e.preventDefault();
            }
        },
        CheckFullWidthForInputs(index,item,elementId)
        {   
            const width = parseInt(item.width);
            if(width < 0) {
                window.showAlert('res_Msgs_NegativePercentage', 'error') 
                this.$nextTick(() => { 
                        item.width= 0;
                });
            } 
            if(item.show == false) {retrun; } 
            const currentWidthWithoutTargetValue = this.GetCurrentWidth(index); 
            if(currentWidthWithoutTargetValue + (isNaN(width) ? 0 : width) > 100)
            {   
                window.showAlert('res_Msgs_Percentage', 'error') 
                this.$nextTick(() => { 
                        item.width= 100 - currentWidthWithoutTargetValue;
                        document.getElementById(elementId).value = 100 - currentWidthWithoutTargetValue;
                });
            }
        }, 
        CheckFullWidthForCheckboxes(index,item,elementId){         
        if(item.show == false) {return;}

        const currentWidthWithoutTargetValue = this.GetCurrentWidth(index); 
            const width = parseInt(item.width); 
                if(currentWidthWithoutTargetValue + (isNaN(width) ? 0 : width) > 100)
                {   
                    window.showAlert('res_Msgs_Percentage', 'error') 
                    this.$nextTick(() => {  
                            item.show = false; 
                    });
                }
        }, 
        GetCurrentWidth(itemIndex)
        {  
            return this.selectedItemGrid.reduce((accumulator, item, index) => { 
                if (item.show == true && index != itemIndex) {
                    const width = parseInt(item.width); 
                    return accumulator + (isNaN(width) ? 0 : width);
                } else {
                    return accumulator; 
                }
                }, 0);
        },
        getTotalActiveWidth() {
            return this.selectedItemGrid.reduce((total, item) => {
                if (item.show === true) {
                    const width = parseInt(item.width);
                    return total + (isNaN(width) ? 0 : width);
                }
                return total;
            }, 0);
        },
        getTotalWidthStatus() {
            const total = this.getTotalActiveWidth();
            if (total < 100) {
                return {
                    type: 'warning',
                    color: 'warning'
                };
            } else if (total > 100) {
                return {
                    type: 'error',
                    color: 'error'
                };
            } else {
                return {
                    type: 'success',
                    color: 'success'
                };
            }
        },
        onDrop(dropResult) 
        {
            this.selectedItemGrid = utils.applyDrag(this.selectedItemGrid, dropResult)
        },  
        removeItemFromList(item)
        {
            this.filterList = this.filterList?.filter(e => e !== item)
            if (item.key=="filter_reference_number") { this.filter_reference_number = ''; }
            if (item.key=="filter_created_date") { this.filter_created_date = ''; }
            if (item.key=="filter_subject") { this.filter_subject = ''; }
            if (item.key=="filter_due_date") { this.filter_due_date = ''; }
            if (item.key=="filter_sender") { this.filter_sender = null; }
            if (item.key=="filter_purpose") { this.filter_purpose = null; }
            if (item.key=="filter_status") { this.filter_status = null; }
            if (item.key=="filter_category") { this.filter_category = null; }
            this.initPage(0)
        }, 
        shouldShowBulkButton(action)
        {
            var showValue = true

            if (action == 'BulkTransfer' && !(this.selected.length > 1 && this.nodeId == 2))
            {
                showValue = false
            }

            for (var i = 0; i < this.selected.length; i++)
            {
                var item = this.selected[i]
                if (item != null && item != undefined)
                {
                    if (action != 'BulkTransfer')
                    {
                        var value1 = utils.ActionsPermission(action, item, item.transferId, this.delegationId, this.nodeId, item.canSign)
                        showValue = showValue && value1
                    }

                    if ((action == 'Archive' || action == 'BulkTransfer') && (item.toUserId == null || item.toUserId == 0))
                    {
                        showValue = false
                    }
                }
            }

            return showValue
        },
        complete()
        {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.selectedItem.item.documentId + '&transferId=' + this.selectedItem.item.transferId)
                .then(res => 
                {
                    if (res.data == 1) 
                    {
                        window.showInformation(this.$t('res_Msgs_Confirmation'), this.$t('res_Msgs_CompleteCorrespondence'),
                            () => 
                            {
                                axios.post(`${constants.baseApiUrl}Transfer/Complete?transferId=${this.selectedItem.item.transferId}`)
                                    .then(res => 
                                    {
                                        if (res.data != null && res.data.length > 0) 
                                        {
                                            let referenceNumber = res.data.join(', ');
                                            let message = this.$t('res_Message_CompleteSuccess', {referenceNumber}); 
                                            window.showAlert(message, 'success');
                                            this.refreshPage();
                                        }
                                        else 
                                        {
                                            window.showAlert('res_Message_CompleteFail', 'warning');
                                        }
                                    })
                                    .catch(err => console.warn(err))
                            },
                            () => {});
                    }
                    else
                    {
                        window.hideLoading()
                        window.showAlert('res_Msgs_TransferNotCompleted', 'warning')
                    }
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
        },
        onDropAction(collection, dropResult) 
        {
              this.grid_headers = applyDrag(collection, dropResult)
        },
		applyDrag(arr, dragResult) 
        {
            const { removedIndex, addedIndex, payload } = dragResult;
            if (removedIndex === null && addedIndex === null) return arr;

            const result = [...arr];
            let itemToAdd = payload;

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }

            result.forEach((item, index) => {
                item.index = index;
            });

            return result;
        },
		getChildPayload2(index) 
        {
            return this.grid_headers[index];
        },
        saveGrid() 
        {
            docActions.AddOrUpdateGridHeaders(this.nodeId, this.selectedItemGrid, (res) =>
            {
                if (res.data == true) 
                {
                    this.GetAllGrid()
                    this.gridHeadersDilaog = false   
                }
            })
        },
        GetAllGrid() 
        {  
            axios.get(`${constants.baseApiUrl}Document/GetAllGridHeaders?nodeId=${this.nodeId}`)
                .then((res) => 
                {
                    if (res.data !== null && res.data !== '') 
                    {
                        let result = [];
                        for (let i = 0; i < res.data.length; i++) 
                        {
                            let item = res.data[i]
                            result.push({
                                ...item,
                                show: item.show == true,
                                text: (item.resourceLabel == '' ? item.text : this.$t(item.resourceLabel)),
                                sortable: item.sortable == true || item.sortable == "true",
                                width: item.width + '%'
                            });
                        }   

                        this.selectedItemGrid = result.map(item=>({...item , width: item.width.replace('%', '')}));
                        this.loadedItemGrid =  result.map(item=>({...item , width: item.width.replace('%', '')}));                        
                        this.grid_headers = this.selectedItemGrid.filter(item => item.show).map(item => ({ ...item , width: `${item.width}%` }))
                        this.grid_headers.push({ value: "actions", width: '10%', sortable: false, show: this.nodeId != 1 })
                        this.gridHeadersDilaog = false 
                    }
                })
                .catch((err) => console.warn(err))
                .finally(() => window.hideLoading());
        },
        closeNewTrackerDialog() 
        { 
		    this.visualTrackingDialogNew = false;
		},
        exportToExcelOrPdf(exportType) 
        {
            this.isExport = true;
            this.exportType = exportType;
            this.getItemsForSelectedInbox(false)
        },
        UndoArchive()
        {
           const transferId =  this.selectedItem.item.transferId;
           if(transferId == null || transferId <= 0 )
           { return; } 
           axios.post(`${constants.baseApiUrl}Document/UndoArchiveDocument?transferId=${transferId}`)
                    .then(res => {
                        if (res.data && res.data.success == true) {
                            // let TransferredTo = res.data.transferredTo; 
                            let message = this.$t('res_Message_UndoArchiveSuccess'); 
                            window.showAlert(message, 'success');
                            this.closePreview();
                            this.refreshPage();
                        }
                        else {
                            window.showAlert('res_Message_UndoArchiveFail', 'warning');
                        }
                    })
                    .catch(err => console.warn(err))
        },
        dismissTransfer()
        {
           const transferId =  this.selectedItem.item.transferId;
           if(transferId == null || transferId <= 0 )
           { return; } 
           axios.get(`${constants.baseApiUrl}Transfer/Dismiss?transferId=${transferId}`)
                    .then(res => {
                        if (res.data && res.data.success == true) {
                            let referenceNumber = res.data.referenceNumber; 
                            let message = this.$t('res_Message_DismissSuccess', {referenceNumber}); 
                            window.showAlert(message, 'success');
                            this.refreshPage();
                        }
                        else {
                            window.showAlert('res_Message_DismissFail', 'warning');
                        }
                    })
                    .catch(err => console.warn(err))
        },
        completeTransfers()
        {
            if (this.selected.length == 0) 
            {
                window.showAlert('res_Msgs_NoItemSelected', 'warning')
                return
            }

            window.showInformation(window.translate('res_Msgs_Confirmation'), window.translate('res_Msgs_TransferCompleteConfirmation'),
                () => 
                {
                    var transferIds = []
                    for (var i = 0; i < this.selected.length; i++) 
                    {
                        transferIds.push(this.selected[i].transferId)
                    }

                    axios.post(constants.baseApiUrl + 'Transfer/CompleteTransfers?transferIds=' + transferIds)
                        .then(response => 
                        {
                            if (response.data != null && response.data.length > 0) 
                            {
                                window.showAlert('res_Msgs_TransferCompleted', 'success');
                                this.refreshPage();
                            }
                        })
                        .catch(error => console.warn(error));
                }, () => { });
        },
        async signDocument() 
        { 
            this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin()
            this.propertyBag.documentId = this.selectedItem.item.documentId.toString()
            this.propertyBag.transferId = this.selectedItem.item.transferId.toString()
            this.propertyBag.delegationId = this.selected_node.delegationId ?? 0
            this.propertyBag.documentHashValue = this.selectedItem.item.hashValue

            if (constants.signUsingUAEPassEnabled || constants.signUsingDocusignEnabled)
            {
                if(this.allowESignature && !this.allowUAEPASSSignature)
                    this.closeSignMethodSelectAndOpenSignWithPin();
                else
                    this.selectSignMethodFormDialog = true
            }
            else
            {
                this.signFormDialog = true
            }
        },
        refreshAfterClosingSignDialog() 
        {
            this.signFormDialog = false
            this.refreshPage();
        },
        refreshAfterClosingSignMethodSelect() 
        {
            this.selectSignMethodFormDialog = false
            this.refreshPage()
        },
        closeSignFormDialog()
        {
            this.signFormDialog = false
        },
        closeSelectSignMethodFormDialog() 
        {
            this.selectSignMethodFormDialog = false
        },
        closeSignMethodSelectAndOpenSignWithPin() 
        {
            this.selectSignMethodFormDialog = false
            this.signFormDialog = true
        },
        IsCced() 
        {
            return this.selectedItem && (this.selectedItem.item.purposeId == constants.purposesEnum.ForInfo || this.selectedItem.item.cCed == true)
        },
        callback() 
        {
            console.log('callback from correspondence dialog')
        },
        initBox()
        {
            this.clearFiltersWithoutinitPage()
            this.initPage(0)

            this.openPreviewPane = false
            this.inboxes = []
            this.inboxes.push({ id: 1, name: this.getInboxName(this.isLanguageEn, 0), inboxId: this.nodeId, delegationId: 0, count: 0 })

            const intervalId = setInterval(() => {
                if (constants.isDelegationsLoaded == true) {
                    clearInterval(intervalId);
                    constants.delegations.forEach((delegation) => {
                        if (delegation.nodeIds != null && delegation.nodeIds != '') {
                            delegation.nodeIds.split(',').forEach((nodeIdItem) => {
                                if (this.nodeId === parseInt(nodeIdItem)) {
                                    var newDelegationNode = {
                                        id: this.inboxes.length + 1,
                                        fullname: delegation.fromUser.trim() + " (" + delegation.structureName.trim() + ")",
                                        name: delegation.fromUserFirstName.trim() + "'s " + this.getInboxName(this.isLanguageEn, 1),
                                        inboxId: this.nodeId,
                                        delegationId: delegation.id,
                                        count: 0
                                    };
                                    if (this.isLanguageEn)
                                        newDelegationNode.name = delegation.fromUserFirstName.trim() + "'s " + this.getInboxName(this.isLanguageEn, 1);
                                    else
                                        newDelegationNode.name = this.getInboxName(this.isLanguageEn, 1) + " الخاص بـ " + delegation.fromUserFirstName.trim();

                                    this.inboxes.push(newDelegationNode)

                                    this.getItemsCountForSelectedInbox(this.nodeId, delegation.id, (count) => { newDelegationNode.count = count })
                                }
                            });
                        }
                    });
                }
            }, 100);

            this.selected_index = 0
            this.selected_node = this.inboxes[0]
            this.clearFiltersWithoutinitPage(0);
            window.refreshInbxGrid = this.initPage

            this.selected = []
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.category_items = constants.categories

            if (this.selectedLang == 'ar')
            {
                this.action_types = getTransferPurposes();
                this.status_types = window.statuses.map(item => ({ ...item,  name: this.selectedLang === 'en' ? item.name : item.nameAr}));
                this.category_items = constants.categories.map(item => ({ ...item,  name: this.selectedLang === 'en' ? item.name : item.nameAr}));
            }
        },
        initPage(ifGrid) 
        {
            // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup
            if (document.querySelectorAll('.v-application--is-rtl').length)
                this.isLanguageEn = false

            if (ifGrid == 0)
            {
                this.pageIndex = 0
            }

            if (this.selectedItemGrid.length == 0)
            {
                this.GetAllGrid()
            }
            
            if (window["inboxHeaders"]) 
            {
                window.inboxHeaders[this.nodeId].forEach(h => {
                    h.text = window.translate(h.text);
                });
                this.grid_headers = window.inboxHeaders[this.nodeId];
            }
            else 
            {                
                if (this.nodeId == 1 && this.selectedItemGrid.length == 0) // draft
                {
                    this.grid_headers = [
                        { text: window.translate("res_MenuItems_ReferenceNumber"),    resourceLabel: 'res_Label_ReferencenNo',          width: '30%',    value: 'referenceNumber',  sortable: false,    show: true },
                        { text: window.translate("res_Label_Subject") ,               resourceLabel: 'res_Label_Subject',               width: '30%',    value: 'subject',          sortable: true,     show: true },
                        { text: window.translate("res_Label_Status"),                 resourceLabel: 'res_Label_Status',                width: '20%',    value: 'status',           sortable: true,     show: true},
                        { text: window.translate("res_Label_Category"),    	          resourceLabel: 'res_Label_Category',              width: '10%',    value: 'categoryId',       sortable: true,     show: true},    
                        { text: window.translate("res_GridHeaders_CreatedDate"),      resourceLabel: 'res_GridHeaders_CreatedDate',     width: '10%',    value: 'createdDate',      sortable: true,     show: true },
                        { text: window.translate("res_Label_Overdue"),                resourceLabel: 'res_Label_Overdue',               width: '10%',    value: 'overdue',          sortable: false,    show: true },
                        { text: window.translate('res_Label_Privacy'),                resourceLabel: 'res_Label_Privacy',               width: '10%',    value: 'privacy',          sortable: true,     show: false }
                    ];

                    this.selectedItemGrid = this.grid_headers;
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item => item.show === true);
                }
                else if (this.nodeId == 2 && this.selectedItemGrid.length == 0) // Inbox = 2
                {
                    this.grid_headers = [
                        { text: window.translate("res_Label_Category"),    	        resourceLabel: 'res_Label_Category',    width: '8%',        value: 'categoryId',          	sortable: true,   show:false},
                        { text: window.translate("res_Label_ReferencenNo"),    	    resourceLabel: 'res_Label_ReferencenNo',    width: '12%',       value: 'referenceNumber',   sortable: false,  show:true},
                        { text: window.translate("res_Label_Subject"),    	        resourceLabel: 'res_Label_Subject',    width: '25%',       value: 'subject',          		sortable: true ,  show:true},
                        { text: window.translate("res_Label_From"),    		        resourceLabel: 'res_Label_From',    width: '11%',       value: 'senderUser',          	    sortable: true,   show:true},
                        { text: window.translate("res_Label_Sender"),    		    resourceLabel: 'res_Label_Sender',    width: '11%',       value: 'sender',          		sortable: true,   show:true},
                        { text: window.translate("res_Label_OpenDate"),             resourceLabel: 'res_Label_OpenDate',                width: '2%',        value: 'openedDate',            sortable: true,   show:false},
                        { text: window.translate("res_GridHeaders_ActionType"),     resourceLabel: 'res_GridHeaders_ActionType',        width: '8%',        value: 'purpose',       sortable: true,   show:true},
                        { text: window.translate("res_Label_Status"),               resourceLabel: 'res_Label_Status',                width: '8%',        value: 'status',                  sortable: true,   show:true},
                        { text: window.translate('res_GridHeaders_DispatchStatus'), resourceLabel: 'res_GridHeaders_DispatchStatus',  width: '6%',    value: 'dispatchStatus',   sortable: false,    show: true },
                        { text: window.translate("res_GridHeaders_DueDate"),        resourceLabel: 'res_GridHeaders_DueDate',    width: '7%',        value: 'dueDate',          sortable: true,   show:true},
                        { text: window.translate("res_GridHeaders_Recieved"),       resourceLabel: 'res_GridHeaders_Recieved',    width: '12%',        value: 'recievedDate',   sortable: true,   show:true},
                        { text: window.translate("res_Label_Overdue"),              resourceLabel: 'res_Label_Overdue',    width: '6%',        value: 'overdue',                sortable: false,  show:true},
                        { text: window.translate("res_Label_CloseDate"),            resourceLabel: 'res_Label_CloseDate',    width: '1%',        value: 'closedDate',           sortable: true,   show:false},
                        { text: window.translate("res_Label_DispatchDate"),    	    resourceLabel: 'res_Label_DispatchDate',    width: '20%',    value: 'dispatchDate',         sortable: true,   show:false},
                    ];

                    this.selectedItemGrid = this.grid_headers
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item => item.show === true);
                }
                else if (this.nodeId == 6 && this.selectedItemGrid.length == 0) // Sent
                {
                    this.grid_headers = [
                        { text: window.translate("res_Label_ReferencenNo"),    	    resourceLabel: 'res_Label_ReferencenNo' , width: '12%',       value: 'referenceNumber',       sortable: false ,show: true},
                        { text: window.translate("res_Label_Subject"),    	        resourceLabel: 'res_Label_Subject' , width: '25%',       value: 'subject',          		sortable: true ,show: true},
                        { text: window.translate("res_GridHeaders_DueDate"),        resourceLabel: 'res_GridHeaders_DueDate' , width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                        { text: window.translate("res_GridHeaders_Recipient"),      resourceLabel: 'res_GridHeaders_Recipient' , width: '8%',        value: 'recipient',          	sortable: true ,show: true},
                        { text: window.translate("res_GridHeaders_SentTo"),         resourceLabel: 'res_GridHeaders_SentTo' , width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                        { text: window.translate("res_GridHeaders_ActionType"),     resourceLabel: 'res_GridHeaders_ActionType' , width: '8%',        value: 'purpose',           	sortable: true ,show: true},
                        { text: window.translate("res_Label_Status"),               resourceLabel: 'res_Label_Status' , width: '8%',        value: 'status',                sortable: true ,show: true},
                        { text: window.translate("res_GridHeaders_SentOn"),         resourceLabel: 'res_GridHeaders_SentOn' , width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                        { text: window.translate("res_Label_Overdue"),              resourceLabel: 'res_Label_Overdue' , width: '1%',        value: 'overdue',               sortable: false,show: false },
                    ];
                
                    this.selectedItemGrid = this.grid_headers
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item => item.show === true);
                }
                else if (this.nodeId == 8 && this.selectedItemGrid.length == 0) // Archived
                {
                    this.grid_headers = [  
                        { text: window.translate("res_Label_ReferencenNo"), resourceLabel: window.translate("res_Label_ReferencenNo"), width: '12%', value: 'referenceNumber', sortable: false, show: true },
                        { text: window.translate("res_Label_Subject"), resourceLabel: window.translate("res_Label_Subject"), width: '25%', value: 'subject', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_DueDate"), resourceLabel: window.translate("res_GridHeaders_DueDate"), width: '8%', value: 'dueDate', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_Recipient"), resourceLabel: window.translate("res_GridHeaders_Recipient"), width: '10%', value: 'recipient', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_SentTo"), resourceLabel: window.translate("res_GridHeaders_SentTo"), width: '10%', value: 'sentTo', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_ActionType"), resourceLabel: window.translate("res_GridHeaders_ActionType"), width: '10%', value: 'purpose', sortable: true, show: false },
                        { text: window.translate("res_Label_Status"), resourceLabel: window.translate("res_Label_Status"), width: '7%', value: 'status', sortable: true, show: true },
                        { text: window.translate('res_GridHeaders_DispatchStatus'),   resourceLabel: 'res_GridHeaders_DispatchStatus',  width: '6%',    value: 'dispatchStatus',   sortable: false,    show: true },
                        { text: window.translate("res_GridHeaders_Recieved"), resourceLabel: window.translate("res_GridHeaders_Recieved"), width: '7%', value: 'recievedDate', sortable: true, show: true },
                        { text: window.translate("res_Label_Overdue"), resourceLabel: window.translate("res_Label_Overdue"), width: '4%', value: 'overdue', sortable: false, show: false },
                        { text: window.translate("res_GridHeaders_ArchivedComment"), resourceLabel: window.translate("res_GridHeaders_ArchivedComment"), width: '1%', value: 'archivedComment', sortable: false, show: false },
                    ];

                    this.selectedItemGrid = this.grid_headers
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item=>item.show === true)
                }
                else if (this.nodeId == 9 && this.selectedItemGrid.length == 0) // Follow-up
                {
                    this.grid_headers = [
                        { text: window.translate("res_Label_ReferencenNo"), resourceLabel: window.translate("res_Label_ReferencenNo"), width: '12%', value: 'referenceNumber', sortable: false, show: true },
                        { text: window.translate("res_Label_Subject"), resourceLabel: window.translate("res_Label_Subject"), width: '25%', value: 'subject', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_DueDate"), resourceLabel: window.translate("res_GridHeaders_DueDate"), width: '8%', value: 'dueDate', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_Recipient"), resourceLabel: window.translate("res_GridHeaders_Recipient"), width: '10%', value: 'recipient', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_SentTo"), resourceLabel: window.translate("res_GridHeaders_SentTo"), width: '10%', value: 'sentTo', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_ActionType"), resourceLabel: window.translate("res_GridHeaders_ActionType"), width: '8%', value: 'purpose', sortable: true, show: true },
                        { text: window.translate("res_Label_Status"), resourceLabel: window.translate("res_Label_Status"), width: '8%', value: 'status', sortable: true, show: true },
                        { text: window.translate("res_GridHeaders_Recieved"), resourceLabel: window.translate("res_GridHeaders_Recieved"), width: '8%', value: 'recievedDate', sortable: true, show: true },
                        { text: window.translate("res_Label_Overdue"), resourceLabel: window.translate("res_Label_Overdue"), width: '7%', value: 'overdue', sortable: false, show: false },
                        { text: window.translate("res_Label_Instruction"), resourceLabel: window.translate("res_Label_Instruction"), width: '1%', value: 'transferInstruction', sortable: false, show: false },
                    ];

                    this.selectedItemGrid = this.grid_headers
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item=>item.show === true)
                }
                else if (this.nodeId == 10 && this.selectedItemGrid.length == 0) { // CCed Inbox
                    this.grid_headers = [
                        { text: window.translate("res_Label_Category"),          resourceLabel: 'res_Label_Category',    width: '8%',        value: 'categoryId',            sortable: true,show:false},
                        { text: window.translate("res_Label_ReferencenNo"),      resourceLabel: 'res_Label_ReferencenNo',width: '12%',       value: 'referenceNumber',        sortable: false ,show:true},
                        { text: window.translate("res_Label_Subject"),           resourceLabel: 'res_Label_Subject',     width: '25%',       value: 'subject',                sortable: true ,show:true},
                        { text: window.translate("res_Label_From"),              resourceLabel: 'res_Label_From',        width: '11%',       value: 'senderUser',             sortable: true ,show:true},
                        { text: window.translate("res_Label_Sender"),            resourceLabel: 'res_Label_Sender',      width: '11%',       value: 'sender',                 sortable: true ,show:true},
                        { text: window.translate("res_Label_OpenDate"),          resourceLabel: 'res_Label_OpenDate',    width: '2%',        value: 'openedDate',             sortable: true,show:false},
                        { text: window.translate("res_GridHeaders_ActionType"),  resourceLabel: 'res_GridHeaders_ActionType',width: '8%',    value: 'purpose',                sortable: true ,show:true},
                        { text: window.translate("res_Label_Status"),            resourceLabel: 'res_Label_Status',      width: '8%',        value: 'status',                 sortable: true ,show:true},
                        { text: window.translate("res_GridHeaders_DueDate"),     resourceLabel: 'res_GridHeaders_DueDate',width: '7%',        value: 'dueDate',                sortable: true ,show:true},
                        { text: window.translate("res_GridHeaders_Recieved"),    resourceLabel: 'res_GridHeaders_Recieved',width: '12%',      value: 'recievedDate',           sortable: true ,show:true},
                        { text: window.translate("res_Label_Overdue"),           resourceLabel: 'res_Label_Overdue',    width: '6%',        value: 'overdue',               sortable: false,show:true},
                        { text: window.translate("res_Label_CloseDate"),         resourceLabel: 'res_Label_CloseDate',   width: '1%',        value: 'closedDate',             sortable: true,show:false},
                        { text: window.translate("res_Label_DispatchDate"),      resourceLabel: 'res_Label_DispatchDate',width: '20%',       value: 'dispatchDate',           sortable: true,show:false},
                    ];
                    this.selectedItemGrid = this.grid_headers;
                    this.loadedItemGrid = this.grid_headers.map(item => ({ ...item }));
                    this.grid_headers = this.grid_headers.filter(item => item.show === true);
                }
            }
            const doesActionsColumnExist = this.grid_headers.some(x => x.value == "actions");
            if(this.nodeId != 1 && !doesActionsColumnExist)
                this.grid_headers.push({ value: "actions", width: '10%', sortable: false, show: this.nodeId != 1 })
            this.getItemsForSelectedInbox(true);
        },
        nodeClicked(item) 
        {
            this.selected = []
            this.selected_index = item.id - 1
            this.selected_node = item
            this.getItemsForSelectedInbox(true) 
        },
        CreateReplyDocument(docId){
            this.messagesUtil.dispatchEvent({ key: "createOutgoingOnIncoming", documentId: docId });
        },
        getItemsForSelectedInbox(isResetPaging) 
        {
            if (isResetPaging) {
                this.pagingData.pageIndex = 0;
            }
           
            var delegationId = 0, sender = '', purpose = '', status = '', category = '';

            if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id))
                delegationId = this.selected_node.delegationId

            if (utils.CheckIfNullOrEmpty(this.filter_sender) == false && utils.CheckIfNullOrEmpty(this.filter_sender.id) == false)
                if (this.filter_sender.id != 0)
                    sender = this.filter_sender.id

            if (utils.CheckIfNullOrEmpty(this.filter_purpose) == false && utils.CheckIfNullOrEmpty(this.filter_purpose.id) == false)
                if (this.filter_purpose.id != 0)
                    purpose = this.filter_purpose.id

            if (utils.CheckIfNullOrEmpty(this.filter_status) == false && utils.CheckIfNullOrEmpty(this.filter_status.id) == false)
                if (this.filter_status.id != 0)
                    status = this.filter_status.id

            if (utils.CheckIfNullOrEmpty(this.filter_category) == false && utils.CheckIfNullOrEmpty(this.filter_category.id) == false)
                if (this.filter_category.id != 0)
                    category = this.filter_category.id

            var request = {
                NodeId: this.nodeId,
                DelegationId: delegationId,
                PageIndex: this.pagingData.pageIndex,
                PageSize: this.pagingData.pageSize,
                SortBy: this.sortBy,
                SortDir: (this.sortDesc ? 'desc' : 'asc'),
                FilterReferenceNumber: this.filter_reference_number,
                FilterCreatedDate: this.filter_created_date,
                FilterSubject: this.filter_subject,
                FilterDueDate: this.filter_due_date,
                FilterSender: sender,
                FilterPurpose: purpose,
                FilterCategory: category,
                FilterStatus: status,
                ForUserOnly: this.forUserOnly,
                ForStructureOnly: this.forStructureOnly,
            }

            window.showLoading();

            if (this.isExport) 
            {
                request.IsExport = this.isExport;
                request.ForPrint = true;
                request.ExportType = this.exportType

                var exportNode = this.exportListName.find(x => x.nodeId == this.nodeId)
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios.post(
                    constants.baseApiUrl + 'Transfer/List',
                    request,
                    {
                        responseType: 'blob'
                    }
                )
                .then((res) => {
                    var blob = new Blob([res.data], { type: "application/octetstream" });
                    const link = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.setAttribute("download", exportNode.name + `${extension}`);
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                })
                .catch((err) => window.hideLoading())
                .finally(() => window.hideLoading())
                this.isExport = false;
                this.exportType = 0;
            } 
            else 
            {
                this.correspondences = [];
                const url = new URL(window.location.href);
                axios.post(constants.baseApiUrl + `Transfer/List`, request)
                    .then((res) => 
                    {
                        this.correspondences = res.data;
                        request.GetCountOnly = true;

                        axios.post(constants.baseApiUrl + 'Transfer/List', request)
                            .then((res) => 
                            {
                                if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)) 
                                {
                                    var index = this.inboxes.findIndex(x => x.id == this.selected_node.id)
                                    this.inboxes[index].count = res.data;
                                }
                                else
                                    this.inboxes[0].count = res.data
                            });

                        setTimeout(() => { this.showTooltips() }, 1000);
                    })
                    .catch((err) => console.log(err))
                    .finally(() => window.hideLoading())
            }
        },
        getItemsCountForSelectedInbox(nodeId, delegationId, successHandler) {       
            var request = {
                NodeId: nodeId,
                DelegationId: delegationId,
                PageIndex: this.pagingData.pageIndex,
                PageSize: this.pagingData.pageSize,
                GetCountOnly: true,
                ForUserOnly: this.forUserOnly,
                ForStructureOnly: this.forStructureOnly
            }

            axios.post(constants.baseApiUrl + 'Transfer/List', request)
                .then((res) => {
                    successHandler(res.data)
                });
        },
        getPinned(item) 
        {
            var isNotRead = (this.getRowClass(item).lastIndexOf('tr-bold') != -1 ? true : false)
            if (isNotRead)
                return 'mdi-not-read'
            else
                return ''
        },
        getStatusClass(item) 
        {
            if (window.statuses != undefined)
            {
                var statusItem = window.statuses.find(x => x.id == item.statusId)
                if (statusItem != null)
                    return statusItem.color;
            }
            return ''
        },
        getPurposeColor(item)
        {
            var purposeItem = this.purposes.find(x => x.id == item.purposeId)
            if (purposeItem != null)
                return purposeItem.color
            return ''
        },
        getDispatchColor(item)
        {
            if(item == 1)
                return "#FEC305"
            else if(item == 2)
                return "#94C15C"
            else if(item == 3)
                return "#eb7f8c"
            else if(item == 4)
                return "#FEC305"
            else if(item == 5)
                return "#94C15C"
            else if(item == 6)
                return "#94C15C"
            else if(item == 6)
                return "#91A7FA"
        },
        getAttachment(hasAttachment) {
            if (hasAttachment == true) return 'mdi-attachment'
        },
        openOptionPane(menuOption) {
            if (menuOption == 3)
                this.showMenu = true;
        },
        viewCorrespondence(item, isFullView)
        {
            if(this.visualTrackingDialog == true) return

            if (this.openOwnerDialog)
            {
                if (this.selectedItem.item == item && isFullView)
                    this.isFullView = true;

                return;
            }

            this.isFullView = isFullView;

            if (this.selectedItem.item == item)
            {
                if (isFullView)
                    this.openCorrespondence();
                return;
            }

            this.selected = [item];
            this.selectedItem = { 'item': item, 'value': true }

            if (!item.transferId)
                item.transferId = 0;

            if ((this.nodeId == 2 || this.nodeId == 10) && utils.CheckIfNullOrEmpty(item.toUserId))
            {
                this.openOwnerDialog = true;
                return;
            }

            if ((this.nodeId == 2 || this.nodeId == 10) && utils.CheckIfNullOrEmpty(item.openedDate))
            {
                this.markTransferAsReadAndLock();
                return;
            }

            // already read, so no badge changes - just keep the counters in sync
            if (window.refreshUnOpenedDocument)
                window.refreshUnOpenedDocument();

            this.openCorrespondence();
        },
        markTransferAsReadAndLock()
        {
            var item = this.selectedItem.item;

            window.showLoading()
            axios.post(constants.baseApiUrl + 'Transfer/MarkTransferAsReadAndLock?transferId=' + item.transferId + '&delegationId='
                + (this.selected_node.delegationId == undefined ? 0 : this.selected_node.delegationId)
                + '&nodeId=' + this.nodeId, null)
                .then((response) =>
                {
                    
                    if (!response || !response.data)
                    {
                        window.showAlert('res_Msgs_CorrespondenceAlreadyOwned', 'warning');
                        this.refreshPage();
                        return;
                    }

                    // open first: openCorrespondence reads item.openedDate to decide whether to
                    // surface the transfer note, and that has to see the row as it was before
                    this.openCorrespondence();

                    var lockInfo = response.data;
                    item.openedDate = lockInfo.openedDate;
                    item.toUserId = lockInfo.toUserId;
                    item.ownerUserId = lockInfo.ownerUserId;
                    item.lockedByUserId = lockInfo.lockedByUserId;
                    item.lockedByDelegatedUserId = lockInfo.lockedByDelegatedUserId;
                    item.lockedDate = lockInfo.lockedDate;

                    // it really is read now, so the sidebar badge of this box can drop
                    if (window.decrementBoxCount)
                        window.decrementBoxCount(this.nodeId);
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading());
        },
        openCorrespondence()
        {
            var item = this.selectedItem.item;

            if (item.attachmentId == null || item.attachmentId == undefined)
            {
                this.empty_viewer = true
            }
            else
            {
                this.empty_viewer = false
                window.setViewerData(item.attachmentId, item.documentId, null, item.subject + '-' + item.referenceNumber, null, item.statusId, item.categoryId);
                this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                    '&viewerMode=collapsed&hideEditInWord=' + (this.nodeId == 6) + '&r=' + new Date().getTime()
            }

            // the letter is actually open from here on, so the row stops showing as unread
            if (!item.openedForPreview)
                item.openedForPreview = true;

            this.isSecretNote = item.isSecretNote;
            this.toUserId = item.toUserId;
            this.itemToBeUpdated = item;
            this.showActionsBtns = false;

            if (item.transferId > 0)
            {
                var context = this
                setTimeout(() => {
                    if (context.$refs.transferNotesIcon)
                        context.$refs.transferNotesIcon.showTransferNotes(item.transferCreatedByUserId, item.transferInstruction, item.documentId)
                }, 50);
            }

            this.handleToolBarWindowResize(false);

            if (this.nodeId == 2 || this.nodeId == 1)
            {
                axios.get(constants.baseApiUrl + 'Document/CheckHasPermissionToSign?documentId=' + item.documentId + '&delegationId='
                + (this.selected_node.delegationId == undefined ? 0 :  this.selected_node.delegationId), null)
                    .then(response => {
                        this.canSignDocument = response.data;
                        this.handleToolBarWindowResize(true);
                    })
                    .catch(error => console.log(error));
            }
            else
            {
                this.showActionsBtns = true;
                this.handleToolBarWindowResize(true);
            }

            this.getEditSignedPermissionRecordFlag();

            if (this.isFullView == false)
            {
                this.openPreviewPane = true;
                return;
            }

            // the full view replaces the preview, it does not stack on top of it
            this.openPreviewPane = false;
            this.showPreviewInstruction = false;

            //  Draft = 1, Inbox = 2, Sent = 6, Archived = 8, Follow-up = 9
            if (this.nodeId == 1)
                this.viewMode = 'edit'
            else if (this.nodeId == 2 && item.categoryId != 1 && item.isSigned != true)
                this.viewMode = 'edit_new'
            else if (this.nodeId == 6 || this.nodeId == 8 || this.nodeId == 9)
                this.viewMode = 'readonly'

            if (item.statusId == 1) // Draft
            {
                this.delegationId = 0
                this.documentId = item.id.toString()
            }
            else
            {
                this.delegationId = this.selected_node.delegationId
                this.transferId = item.transferId.toString()
                this.documentId = item.documentId.toString()
            }

            if (this.nodeId == 9)
            {
                this.toEmail = item.sentToEmail
                this.emailCC = item.sentToManagerEmail
            }

            this.correspondenceDialog = true
        },
        CapitalizeFirstLetter(str)
        {
            return utils.CapitalizeFirstLetter(str)
        },
        ownerDialogDescription()
        {
            let retVal = utils.describeCorrespondence(this.selectedItem.item);
            return retVal;
        },
        ownerDialogConfirmed()
        {
            this.openOwnerDialog = false;
            this.markTransferAsReadAndLock();
        },
        ownerDialogDeclined()
        {
            this.selected = [];
            this.closePreview();
        },
        cancelFollowup() 
        {
            var transferId = this.selectedItem.item.transferId

            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_FollowUpCancelConfirmation"),
                () => {
                    var methodUrl = "Followup/CancelFollowup?transferId=" + transferId
                    axios.post(constants.baseApiUrl + methodUrl, null, { headers: constants.headers })
                        .then(() => {
                            window.showAlert("res_Msgs_FollowUpCancellation", 'success')
                            this.refreshPage()
                        })
                        .catch(err => console.warn(err))
                },
                () => { })
        },
        itemSelected(item) 
        {
            if (this.selected.length > 0)
            {
                this.openPreviewPane = false
            }
            
            // this.selectedItem = item
            if (this.nodeId == 2 || this.nodeId == 1) 
            {
                axios.get(constants.baseApiUrl + 'Document/CheckHasPermissionToSign?documentId=' + item.item.documentId + '&delegationId=' 
                    + (this.selected_node.delegationId == undefined ? 0 :  this.selected_node.delegationId), null)
                    .then(response => 
                    {
                        item.item.canSign = response.data;
                    })
                    .catch(error => console.log(error));
            }
        },
        closePreview() 
        {
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.openPreviewPane = false
            this.openOwnerDialog = false
        },
        refreshPage() {
            this.selected = [];
            this.closePreview();
            this.initPage(0);
        },
        refreshPageGrid()
        {
            this.selected = []
            this.closePreview();
            this.initPage(1);
        },
        getInboxName(isLanguageEn, isDelegation) {
            switch (this.nodeId) {
                case 1:
                    return isLanguageEn ? 'Draft' : 'المسودات';
                case 2:
                    return isLanguageEn ? 'Inbox' : 'صندوق المراسلات';
                case 6:
                    return isLanguageEn ? 'Sent' : 'المرسلة';
                case 7:
                    return isLanguageEn ? 'Hidden' : 'المخفي';
                case 8:
                    return isLanguageEn ? 'Archive' : 'الأرشيف';
                case 9:
                    return isLanguageEn ? 'Follow up' : 'المتابعة';
                case 10:
                    return isLanguageEn ? 'Cced Inbox' : 'النسخ';
                case 4:
                    return isLanguageEn ? 'Via Email' : 'عبر البريد الاكتروني';
                case 66:
                    return isLanguageEn ? 'All Sent' : 'جميع المرسل';
                default:
                    return 'Inbox'
            }
        },
        deleteDraftDocument() {
            if (![1,2].includes(this.selectedItem.item.statusId)) {
                window.showAlert('res_Msgs_CantDeleteAlreadyRegisteredDocument', 'error');
                return;
            }

            var hasReferenceSequence = this.selectedItem.item.referenceSequence != null && this.selectedItem.item.referenceSequence != ''

            if(hasReferenceSequence)
                return window.showAlert('res_Msgs_CantDeleteDraftWithRefSequence', 'error');
            
            let description = utils.describeCorrespondence(this.selectedItem.item);
            let confirmation = utils.escapeHTML(this.$t('res_Msgs_DeleteDraftsConfirmation'));

            if (description)
                confirmation += '<br><br>' + description;

            window.showInformation(this.$t('res_Msgs_Confirmation'), confirmation,
            () => {
                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/Delete?documentId=' + this.selectedItem.item.id)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert('res_Msgs_DraftDocumentDeleted', 'success')
                        this.openPreviewPane = false;
                        this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
                        this.$nextTick(() => {
                            this.initPage(0)
                        });
                    }
                    else {
                        window.showAlert('res_Msgs_DraftDocumentDeletionFailed', 'error')
                    }
                })
                .catch((err) => { console.log(err); window.hideLoading(); })
                .finally(() => { window.hideLoading(); })
            }, () => { }, true);
        },
        DismissCced() {
            window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_TransferDismissConfirmation"),
                () => {
                    window.showLoading()
                    axios.get(constants.baseApiUrl + 'Transfer/DismissCcedTransfer?transferId=' + this.selectedItem.item.transferId)
                        .then(res => {
                            if (res.data != null && res.data > 0) {
                                window.showAlert('res_Msgs_TransferDismiss', 'success')
                                this.refreshPage();
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => { window.hideLoading(); })
                }, () => { });
        },
        dismissSent()
        {
            window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_TransferDismissConfirmation"),
                () => {
                    window.showLoading();
                    axios.post(constants.baseApiUrl + 'Transfer/DismissSentTransfer?transferId=' + this.selectedItem.item.transferId)
                    .then(res => {
                        if (res.data != 0) {
                            window.showAlert('res_Msgs_TransferDismiss', 'success')
                            this.refreshPage();
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
                }, () => { }); 
        },
        closeCorrespondenceDialog() {
            this.delegationId = '0'
            this.documentId = '0'
            this.transferId = '0'

            // Clear email-link session state so stale values don't affect subsequent operations
            sessionStorage.removeItem('transferId');
            sessionStorage.removeItem('docId');
            sessionStorage.removeItem('delegationId');
            this.correspondenceDialog = false

            this.selected = [];
            this.closePreview();
            this.getItemsForSelectedInbox(false)
        },
        async OpenTransferForm(action) {
            this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin()
            this.delegationId = this.selected_node.delegationId
            this.rejected = false
            this.sentBack = false;
            this.forwardCC = false
            this.recipientDisabled = false
            const transferIds = this.selected.map(item => item.transferId);
            this.transferId = transferIds.length > 0 ? transferIds.join(',') : this.selectedItem.item.transferId.toString();
            const documentIds = this.selected.map(item => item.documentId);
            this.documentId = documentIds.length > 0 ? documentIds.join(',') : this.selectedItem.item.documentId.toString();
            this.signForm = false

            this.propertyBag.documentId = this.selectedItem.item.documentId.toString()
            this.propertyBag.transferId = this.selectedItem.item.transferId.toString()
            this.propertyBag.delegationId = this.selected_node.delegationId ?? 0
            this.propertyBag.documentHashValue = this.selectedItem.item.hashValue

            if (action == 'Endorse') {
                this.recipientDisabled = true
                this.transferSuccessMessage = 'res_Msgs_DocumentEndorsed'
                this.transferFormHeader = window.translate("res_MenuItems_Endorse")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                    this.purpose = { id: 8, name: this.selectedLang == 'ar' ? 'للتوقيع' : 'For Signature' }
                }
                
                //this.purpose = { id: 15, name: 'For Endorsement' }
                this.getNextReceiver(false, true)
            }
            else if (action == 'Forward') {               
                this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                this.checkForAttachmentsUploadMultiApproval = true
                this.transferFormHeader = window.translate("res_MenuItems_Forward")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                    this.purpose = { id: 3, name: this.selectedLang == 'ar' ? 'للإجراء اللازم' : 'For Action' } 
                }
               
                this.getNextReceiver(false, false)
            }
            else if (action == 'ForwardCc') {
                this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                this.checkForAttachmentsUploadMultiApproval = true
                this.transferFormHeader = window.translate("res_MenuItems_Forward")
                this.purpose = { id: 10, name: this.selectedLang == 'en' ? 'Cced' : 'نسخة' }
                this.forwardCC=true
                //this.getNextReceiver(false, false)
            }
            
            else if (action == 'Sign') {
                this.transferSuccessMessage = 'res_Msgs_DocumentSignedAndSent'
                this.transferFormHeader = window.translate("res_ButtonText_SignAndTransfer")

                this.purpose = { id: 8, name: this.selectedLang == 'ar' ? 'للتوقيع' : 'For Signature' }  
               
                this.signForm = true
                this.getNextReceiver(true, false)
            }
            else if (action == 'Rejected') {
                this.transferSuccessMessage = 'res_Msgs_DocumentRejected'
                this.recipientDisabled = false
                this.rejected = true
                this.signForm = utils.checkCanSignDocument(this.selectedItem.item, this.selected_node.delegationId, this.canSignDocument, 'reject');
                this.transferFormHeader = window.translate("res_DialogTitle_Rejected")
                this.purpose = { id: 12, name: this.selectedLang == 'ar' ? 'مرفوض' : 'Rejected' }
                this.GetInitiator(this.documentId)
            }
            else if (action == 'Send Back') {
                
                this.sentBack = true;
                if(this.selectedItem.item.toUserId == null){
                    window.showAlert(this.$t('res_Msgs_CantSendBack'));
                    return;
                }
                this.transferSuccessMessage = 'res_Msgs_DocumentSentBack'
                this.recipientDisabled = true
                this.transferFormHeader = window.translate("res_MenuItems_SendBack")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                    this.purpose = { id: 3, name: this.selectedLang == 'ar' ? 'للإجراء اللازم' : 'For Action' }
                }
                
                this.signForm = false
                this.GetPreviousSender(this.transferId)
            }
            this.disableAdvancedTransfer = !this.selectedItem.item.isSigned;
            
            let missingOtherAttachments = this.selectedItem.item.hasOtherAttachments == 1;
            let missinglinkedDocuments  = this.selectedItem.item.hasLinked == 1;
            if( window.enableConfirmOntransferOtherInfo == true  &&
              (missinglinkedDocuments|| missingOtherAttachments) &&
              (this.selectedItem.item.transferId <= 0 || this.selectedItem.item.transferId== null)  
              && this.selectedItem.item.categoryId == 2
            ){ 
                let missingData = [];
                if(missinglinkedDocuments)
                { missingData.push(this.$t('res_CardHeaders_LinkedEmails')); }
                if(missingOtherAttachments)
                { missingData.push(this.$t('res_Label_OtherAttachments')); }
                let customMessage = missingData.length == 1 ? missingData[0] : `(${missingData.join(',')})`;
                window.showInformation(
                this.$t('res_Msgs_Confirmation'),
                this.$t('res_Msgs_DocumentHasNoLinkedDocsAndOtherAttachments', { customMessage }),
                () => { this.transferFormDialog = true },
                () => {})
            }
            else{
                this.transferFormType = action
                this.transferFormDialog = true
            }
            
            
        },
        closeTransferFormDialog() {
            //this.closePreview()
            this.transferFormDialog = false
            this.disableAdvancedTransfer = true
            this.refreshPage()
        },
        getNextReceiver(isSign, isEndorse) {
            this.transferCC = []
            this.transferTo = null
            this.transferToMulti = []
            const documentIds = this.selected.map(item => item.documentId);
            this.documentId = documentIds.length > 0 ? documentIds.join(',') : this.selectedItem.item.documentId.toString();
            defaultGet('Transfer/GetDocumentNextDefaultReceiver?docId=' + this.documentId + '&isSign=' + isSign + '&isEndorse=' + isEndorse + '&delegationId=' 
                + (this.selected_node.delegationId == undefined ? 0 :  this.selected_node.delegationId),
                (res) => {
        if (res.data != null && res.data != undefined) {
            if (res.data.length > 0 && res.data[0].id != 0) {
                var isMultiForwardEnabled = false
                var notCcedElements = res.data.filter(x => x.isCced == false)
                if (notCcedElements.length > 1)
                    isMultiForwardEnabled = true

                res.data.forEach(element => {
                    var purposeName = '';
                    var selectedPurpose = this.purposes.find(x => x.id == element.purpose);

                    if (selectedPurpose != undefined && selectedPurpose != null) {
                        purposeName = this.selectedLang == 'ar' ? selectedPurpose.nameAr : selectedPurpose.name;
                        if (constants.client_version_Id == 'ADHA') {
                            this.purpose = { id: 0, name: '' };
                        } else {
                            this.purpose = { id: element.purpose, name: purposeName };
                        }
                    }

                    if (element.isCced)
                        this.transferCC.push(element);
                    else {
                        if (element.name != "0") {
                            if (isMultiForwardEnabled == false)
                                this.transferTo = element;
                            else
                                this.transferToMulti.push(element);
                        }
                    }
                });

            }
        }
    }, this.handleError, true);
        },
        GetPreviousSender(transferId) {
            defaultGet('Transfer/GetPreviousSender?transferId=' + transferId,
                (res) => {
                    if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                        this.transferTo = res.data
                    }
                }, this.handleError, true);
        },
        GetInitiator(documentId) {
            defaultGet('Transfer/GetInitiator?documentId=' + documentId,
                (res) => {
                    if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                        this.transferTo = res.data
                    }
                }, this.handleError, true);
        },
        handleError(error) {
            this.loading = false
            console.log(error)
            window.showAlert('res_Msgs_ErrorOccured', 'error')
        },
        openVisualTrackingFromInbox(documentId = 0) {
            if (window.enableVisualTracker2 == true) {
                this.visualTrackingDialogNew_selectedDocumentId = documentId > 0 ? documentId.toString() : this.selectedItem.item.documentId.toString();
                this.visualTrackingDialogNew = true;
            } else {
                this.signingHistoryDialog = false
                var lang = localStorage.getItem('lang')
                lang = ((lang == null || lang == undefined) ? 'en' : lang);
                window.setVisualTrackingData(documentId > 0 ? documentId : this.selectedItem.item.documentId);
                this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                this.visualTrackingDialog = true
                //window.open(this.trackingFrameSrc, "_blank");
            }
        },
        openVisualTracking() {  
            if (window.enableVisualTracker2 == true) { 
                
                this.visualTrackingDialogNew_selectedDocumentId = this.selectedItem.item.documentId.toString();
                this.visualTrackingDialogNew = true;  
            }
            else
            {
                this.signingHistoryDialog = false
                // this.visualTrackingDialog = true 
                var lang = localStorage.getItem('lang')
                lang = ((lang == null || lang == undefined) ? 'en' : lang);
                window.setVisualTrackingData(this.selectedItem.item.documentId);
                this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                window.open(this.trackingFrameSrc, "_blank");
            } 
        },
        openSigningHistory() 
        {
            this.selectedDocumentId = this.selectedItem.item.documentId.toString()
            this.signingHistoryDialog = true
        },
        notifyEmailCorrespondence(value) 
        {
            this.notifySubject = this.$t('res_Msgs_Reminder') + this.selectedItem.item.subject;
            //this.emailCC = this.selectedItem.item.sentToManagerEmail;
            //this.toEmail = this.selectedItem.item.sentToEmail;
            this.selectedDocumentId = this.selectedItem.item.documentId.toString();
            this.selectedTranferId = this.selectedItem.item.transferId.toString()
            this.notifyEmailKey++;
            this.notifyEmailDialog = value;
        },
        // downloadCorrespondence(value) 
        // {            
        //     this.withAttachments = value;
        //     var methodUrl = 'Document/Download?documentId=' + this.selectedItem.item.documentId
        //     if (this.withAttachments)
        //         methodUrl = 'Document/DownloadWithAttachments?documentId=' + this.selectedItem.item.documentId

        //     utils.DownloadFile(constants.baseApiUrl + methodUrl, this.selectedItem.item.subject + '-' + this.selectedItem.item.referenceNumber + '.pdf')
        // },
        downloadCorrespondences(value)
        {
            var documentIds = this.selected.map(item => item.documentId).toString()
            var refenceNumbers = '';

            if(this.selected.length == 1)
            {
                refenceNumbers = this.selected[0].referenceNumber;
            }
            else
            {
                refenceNumbers = this.selected.map(item => item.referenceNumber).join(', ');
            }
            
            this.withAttachments = value;
            var methodUrl = 'Document/DownloadMulti?documentIds=' + documentIds
            if (this.withAttachments)
                methodUrl = 'Document/DownloadMultiWithAttachments?documentIds=' + documentIds
            
            utils.DownloadFile(constants.baseApiUrl + methodUrl, refenceNumbers + '.pdf')
        },
        DownloadAttachmentsAsZip()
        {
            var documentIds = this.selected.map(item => item.documentId).toString()
            var refenceNumbers = '';

            if(this.selected.length == 1)
            {
                refenceNumbers = this.selected[0].referenceNumber;
            }
            else
            {
                refenceNumbers = this.selected.map(item => item.referenceNumber).join(', ');
            }
                
            var methodUrl = 'Document/DownloadMultiWithAttachmentsAsZip?documentIds=' + documentIds
            
            utils.DownloadFile(constants.baseApiUrl + methodUrl, refenceNumbers + '.zip')
        },
        bulkTransfers()
        {
            this.bulkTransferDialogKey = this.bulkTransferDialogKey + 1;
            this.bulkTransferFormDialog = true;
        },
        async deleteDrafts()
        {
            if (this.selected.length == 0)
            {
                window.showAlert('res_Msgs_NoItemSelected', 'warning')
                return
            }

            var hasReferenceSequence = false;
            this.selected.forEach(element => {
                if (element.referenceSequence != null && element.referenceSequence != '') {
                    hasReferenceSequence = true;
                }
            });

            if(hasReferenceSequence)
                return window.showAlert('res_Msgs_CantDeleteDraftWithRefSequence', 'error');

            let documentIds = this.selected.map(item => item.documentId)
            let describedItems = this.selected.map(item => utils.describeCorrespondence(item)).filter(description => description)

            let confirmation = utils.escapeHTML(this.$t('res_Msgs_DeleteDraftsConfirmation'));

            if (describedItems.length > 0)
                confirmation += '<br><br>' + describedItems.slice(0, 8).join('<br><br>') + (describedItems.length > 8 ? '<br><br>...' : '');

            window.showInformation(this.$t('res_Msgs_Confirmation'), confirmation,
            
            async () =>
            {
                try
                {
                    const res = await axios.post(constants.baseApiUrl + 'Document/DeleteDrafts', documentIds);
                    if (res.data == true)
                    {
                        window.showAlert('res_Msgs_DraftDocumentDeleted', 'success')
                        this.refreshPage()
                    }
                    else
                    {
                        window.showAlert('res_Msgs_DraftDocumentDeletionFailed', 'error')
                    }
                }
                catch (err)
                {
                    console.log(err);
                    window.showAlert('res_Msgs_DraftDocumentDeletionFailed', 'error')
                }
            }, () => { }, true);
        },
        CreateOutgoing() 
        {
            this.messagesUtil.dispatchEvent({ key: "createOutgoingOnIncoming", documentId: this.selectedItem.item.documentId });
        },
        sendCorrespondence(value) 
        {
            this.withAttachments = value;
            this.selectedDocumentId = this.selectedItem.item.documentId.toString()
            this.dispatchByEmailComponentKey = (this.dispatchByEmailComponentKey || 0) + 1
            this.emailDispatchDocumentDialog = true
        },
        asyncFindSender(query) 
        {
            this.loading = true
            utils.defaultGet(
                'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=false&search=' + query,
                (res) => { this.sender_items = res.data; this.loading = false; },
                () => { this.loading = false; }, true);
        },
        clearFilters() {
            this.clearFiltersWithoutinitPage()
            this.initPage(0)
        },
        clearFiltersWithoutinitPage() {
            this.filter_reference_number = ''
            this.filter_created_date = ''
            this.filter_subject = ''
            this.filter_due_date = ''
            this.filter_sender = null
            this.filter_purpose = null
            this.filter_status = null
            this.filter_category = null
            this.shown = false
            this.filterList = []
        },
        applyFilters() {
            this.selected = []
            this.filterList=[]
            this.closePreview()
            this.shown = false
            if(this.filter_reference_number!=''&&!this.findFilterFromList("filter_reference_number"))this.filterList.push({value:this.filter_reference_number,key:"filter_reference_number"})
            if(this.filter_created_date!=''&&!this.findFilterFromList("filter_created_date"))this.filterList.push({value:this.filter_created_date,key:"filter_created_date"})
            if(this.filter_subject!=''&&!this.findFilterFromList("filter_subject"))this.filterList.push({value:this.filter_subject,key:"filter_subject"})
            if(this.filter_due_date!=''&&!this.findFilterFromList("filter_due_date"))this.filterList.push({value:this.filter_due_date,key:"filter_due_date"})
            if(this.filter_sender!=null&&!this.findFilterFromList("filter_sender"))this.filterList.push({value:this.filter_sender,key:"filter_sender"})
            if(this.filter_purpose!=null&&!this.findFilterFromList("filter_purpose"))this.filterList.push({value:this.filter_purpose,key:"filter_purpose"})
            if(this.filter_status!=null&&!this.findFilterFromList("filter_status"))this.filterList.push({value:this.filter_status,key:"filter_status"})
            if(this.filter_category!=null&&!this.findFilterFromList("filter_category"))this.filterList.push({value:this.filter_category,key:"filter_category"})
            this.initPage(0)
        },
        findFilterFromList(filter){
            var isPresent = false;
            for(let i=0;i<this.filterList.length;i++){
                if(this.filterList[i].key==filter)
                {
                    isPresent=true;
                    break;
                }
            }
            return isPresent;
        },
        isCced() {
            return this.selectedItem.item.purposeId == constants.purposesEnum.ForInfo || this.selectedItem.item.cCed == true
        },
        isSendBackEnabled() {
            // 8: For Signature, 15: For Endorsement
            return (this.nodeId === 2 && this.selectedItem.item.cCed == false)
        },
        isRejectEnabled() {
            // 8: For Signature, 15: For Endorsement
            return (this.nodeId === 2 && this.isCced() == false && this.selectedItem.item.categoryId != 1 && (this.selectedItem.item.purposeId === constants.purposesEnum.ForSignature || this.selectedItem.item.purposeId === constants.purposesEnum.ForAction))
        },
        recall() {
            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_TransferRecallConfirmation"),
                () => {
                    utils.defaultPost('Document/Recall?transferId=' + this.selectedItem.item.transferId, null,
                        (res) => {
                            if (res.data.item1 == true) {
                                window.showAlert('res_Msgs_TransferRecalled', 'success')
                                this.refreshPage()
                            }
                            else {
                                // item2 carries the reason: TransferWasOpened / TransferIsClosed / TransferAlreadyRecalled
                                var reasonKey = 'res_Msgs_TransferRecallFailed_' + res.data.item2
                                var reason = window.translate(reasonKey)
                                window.showAlert(reason && reason !== reasonKey ? reason : 'res_Msgs_TransferRecallFailed', 'warning')
                            }
                        }, this.handleError, true);
                },
                () => { })
        },
        openDeliveryNote() {
            if(!(this.selectedItem.item.statusId == 3 || this.selectedItem.item.statusId == 5))
            {
                window.showAlert(this.$t('res_Msgs_TheCorrespondenceMustBeSignedFirst'), 'warning')
                return;
            }
            this.documentId = this.selectedItem.item.documentId.toString();

            axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' + this.documentId)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert('res_Msgs_DeliveryNoteCreationValidation', 'warning')
                    }
                    else {
                        this.referenceNumber = this.selectedItem.item.referenceNumber;
                        this.deliveryNoteDialog = true;
                    }
                })
                .catch((err) => { console.log(err); window.hideLoading(); })
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        closeDeliveryNoteDialog() {
            this.deliveryNoteDialog = false
            this.refreshPage()
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
        },
        getRowClass(item) {
            var retVal = ''
            
            if (item.openedDate || item.closedDate || item.openedForPreview || (this.nodeId != 2 && this.nodeId != 10))
                retVal = ''
            else
                retVal = 'tr-bold' + ' '

            if (this.selectedItem != null && this.selectedItem.item != null && item == this.selectedItem.item) {
                this.selectedItem.value = true
                retVal += 'custom-class'
            }

            return retVal
        },
        showTooltip(text) {
            const element = this.$refs.ellipsisElements;
            if (element) {
                element.textContent = text;
                return element.offsetHeight < element.scrollHeight;
            }

            return false;
        },
        showTooltips() {
            var elements = document.getElementsByClassName('td-text-limit');
            for (var i = 0; i < elements.length;) {
                var element1 = elements[i];
                var element2 = elements[i + 1];
                var showTooltip = element1.offsetHeight < element1.scrollHeight;
                if (element1.id.lastIndexOf('ellipsisElements') != -1 && element2.id.lastIndexOf('ellipsisElements') != -1) {
                    if (showTooltip) {
                        element1.style.display = 'none';
                        element2.style.display = '-webkit-box';
                    }
                    else {
                        element1.style.display = '-webkit-box';
                        element2.style.display = 'none';
                    }
                }

                i = i + 2;
            }
        },
        updateSortBy(column) 
        {
            this.sortBy = column;
            this.sortDesc = false;
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.getItemsForSelectedInbox(true);
        },
        updateSortDesc(desc) 
        {
            this.sortDesc = desc;
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.getItemsForSelectedInbox(true)
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getItemsForSelectedInbox(false);
        },
        openCompleteDocumentDialog() {
            window.showLoading()
            let transferIds = this.selected.map(item => item.transferId).join(',') || this.selectedItem.item.transferId;
            let documentIds = this.selected.map(item => item.documentId).join(',') || this.selectedItem.item.documentId;
            let needClassification = window.documentNeedClassification;
            axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + documentIds + '&transferId=' + transferIds + '&needClassification=' + needClassification)
                .then(res => {
                    this.completeDocumentDialog = true
                    this.completeDocument_noteText = ''
                    window.hideLoading()
                })
                .catch((err) => { console.log(err); })
                .finally(() => { window.hideLoading(); })
        },
        completeDocument() {
            if (this.completeDocument_noteText.trim().length == 0 || (utils.CheckIfNullOrEmpty(this.classificationPlanId) && this.showClassificationField == true)) {
                window.showAlert('res_Msgs_FillRequired', 'warning')
                return
            }
            let transferIds = this.selected.map(item => item.transferId).join(',') || this.selectedItem.item.transferId;
            let documentIds = this.selected.map(item => item.documentId).join(',') || this.selectedItem.item.documentId;
  
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + documentIds + '&transferId=' + transferIds + '&needClassification=' + false)
                .then(res => {
                    if (res.data == 1 || res.data == 'True') {
                        var body = { 
                            documentId: documentIds, 
                            transferId: transferIds, 
                            instructions: this.completeDocument_noteText, 
                            classificationPlanId: this.showClassificationField == true? this.classificationPlanId : null,
                            delegationId: this.selected_node.delegationId
                        };

                        axios.post(constants.baseApiUrl + 'Document/CompleteDocument', body, { headers: constants.headers })
                            .then(() => {
                                window.showAlert('res_Msgs_DocumentCompletedSuccess', 'success')
                                this.completeDocumentDialog = false;
                                this.refreshPage()
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
                    }
                    else {
                        window.hideLoading()
                        window.showAlert('res_Msgs_DocumentNotArchived', 'warning')
                    }
                })
                .catch(error => {
                    console.log(error)
                    window.hideLoading()
                    this.completeDocumentDialog = false
                })
        },
        SaveForLater() {
            if (this.hideToDate == '') {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                return
            }
            window.showLoading();
            axios.get(constants.baseApiUrl + 'Document/SaveForLater?transferId=' + this.selectedItem.item.transferId + '&toDate=' + this.hideToDate)
                .then((res) => {
                    if (res.data == false) {
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    this.hideCorrespondenceDialog = false;
                    this.hideToDate = '';
                    this.hideToDateMenu = false;
                    this.refreshPage();
                })
                .catch((err) => { console.log(err); })
                .finally(() => { window.hideLoading(); })
        },
        returnToInbox() {
            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_ReturnToInboxConfirmation"),
                () => {
                    window.showLoading();
                    axios.get(constants.baseApiUrl + 'Document/ReturnToInbox?transferId=' + this.selectedItem.item.transferId)
                        .then((res) => {
                            if (res.data == false) {
                                window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                            }
                            this.refreshPage();
                            window.showAlert(this.$t('res_Msgs_ReturnToInboxSuccess'), 'success')
                        })
                        .catch((err) => { console.log(err); })
                        .finally(() => { window.hideLoading(); })
                }, () => { })
        },
        // ReminderByEmail() {
        //     if (this.reminderToDate == '') {
        //         window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
        //         return
        //     }
        //     window.showLoading();
        //     axios.post(constants.baseApiUrl + 'Transfer/ReminderByEmail?transferId=' + this.selectedItem.item.transferId + '&toDate=' + this.reminderToDate + '&toEmails=' + this.fromEmail)
        //         .then((res) => {
        //             if (res.data == false) {
        //                 window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
        //             }
        //             window.showAlert(this.$t('res_Msgs_ReminderAlert'), 'success')
        //             this.reminderEmailDialog = false;
        //             this.reminderToDate = '';
        //             this.hideToDateMenu = false;
        //             this.refreshPage();
        //         })
        //         .catch((err) => { console.log(err); })
        //         .finally(()=>{ window.hideLoading(); })
        //     },
            resetDocument() {
                window.showLoading();
                axios.patch(constants.baseApiUrl + 'Document/ResetDocument?documentId=' + this.selectedItem.item.documentId + '&transferId=' + this.selectedItem.item.transferId, null)
                    .then((res) => {
                        if (res && res.data == "AdvanceGeneratedReferenceNumberAndReplacedOrginialMail") {
                            window.showAlert(this.$t('res_Msgs_CannotResetAdvanceGeneratedRefNumAndReplacedOrignal'), 'warning');
                            return
                        }

                        if (!utils.CheckIfNullOrEmpty(res))
                            window.showAlert('res_Msgs_SuccessTheDocumentHasBeenReset', 'success');

                        this.refreshPageGrid()
                        this.closePreview()
                    })
                    .catch(error => console.log(error))
                    .finally(() => { window.hideLoading(); })
            },
            getCategoryTitle(categoryId)
            {
                var category = this.category_items.find(x => x.id == categoryId)
                if (category != null && category != undefined)
                    return (this.isLanguageEn ? category.name : category.nameAr)
                else
                    return ''
            },
            handleToolBarWindowResize(fireResize)
            {
                this.toolbarButtons = [];
                this.moreActionButtons = [];

                var allBtns = [
                    { btnClass: 'light-blue',       btnClick: () => this.deleteDraftDocument(), btnText: 'res_ButtonText_Delete', btnIcon: undefined, btnPermission: 'DeleteDraft' },
                    { btnClass: 'light-blue',       btnClick: () => this.recall(), btnText: 'res_MenuItems_Recall', btnIcon: undefined, btnPermission: 'Recall' },
                    { btnClass: 'light-success',    btnClick: () => this.signDocument(), btnText: 'res_ButtonText_Sign', btnIcon: undefined, btnPermission: 'Sign' },
                    { btnClass: 'light-success',    btnClick: () => this.OpenTransferForm('Sign'), btnText: 'res_ButtonText_SignAndTransfer', btnIcon: undefined, btnPermission: 'SignAndSend' },
                    { btnClass: 'danger',           btnClick: () => this.OpenTransferForm('Rejected'), btnText: 'res_ButtonText_Reject', btnIcon: 'mdi-close-circle', btnPermission: 'Reject' },
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('Forward'), btnText: 'res_MenuItems_Forward', btnIcon: undefined, btnPermission: 'Forward' },
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('ForwardCc'), btnText: 'res_MenuItems_ForwardCC', btnIcon: undefined, btnPermission: 'ForwardCc' },
                    
                    { btnClass: 'light-blue',       btnClick: () => this.notifyEmailCorrespondence(true), btnText: 'res_MenuItems_NotifyEmail', btnIcon: undefined, btnPermission: 'NotifyEmail'},
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('Endorse'), btnText: 'res_MenuItems_Endorse', btnIcon: undefined, btnPermission: 'Endorse' },
                    { btnClass: 'light-blue',       btnClick: () => this.openCompleteDocumentDialog(), btnText: 'res_ButtonText_Archive', btnIcon: undefined, btnPermission: 'Archive' },
                    { btnClass: 'light-blue',       btnClick: () => this.UndoArchive(), btnText: 'res_ButtonText_UndoArchive', btnIcon: undefined, btnPermission: 'UndoArchive' },
                    { btnClass: 'light-blue',       btnClick: () => this.dismissTransfer(), btnText: 'res_ButtonText_isDismiss', btnIcon: undefined, btnPermission: 'Dismiss' },
                    { btnClass: 'light-blue',       btnClick: () => this.dismissSent(), btnText: 'res_MenuItems_Dismiss', btnIcon: undefined, btnPermission: 'DismissSent' },
                    { btnClass: 'light-blue',       btnClick: () => this.completeTransfers(), btnText: 'res_ButtonText_Complete', btnIcon: undefined, btnPermission: 'Complete' },              
                    { btnClass: 'light-blue',       btnClick: () => this.DismissCced(), btnText: 'res_Label_CcedDismiss', btnIcon: undefined, btnPermission: 'DismissCced' },
                    { btnClass: 'light-blue',       btnClick: () => this.returnToInbox(), btnText: 'res_ButtonText_ReturnToInbox', btnIcon: undefined, btnPermission: 'ReturnToInbox' },
                ]

                var context = this;

                function onResize()
                {
                    context.toolbarButtons = [];
                    context.moreActionButtons = [];

                    var rowContainer = document.getElementById("rowContainer");

                    var width = rowContainer ? rowContainer.clientWidth - (150 + 150 + 40 + 20 + 130) : 0; //static buttons + More Actions

                    for (var i=0; i < allBtns.length; i++)
                    {
                        if (!utils.ActionsPermission(`${allBtns[i].btnPermission}`, context.selectedItem.item, context.selectedItem.item.transferId, context.selected_node.delegationId, context.nodeId, context.canSignDocument))
                            continue;

                        if (width > 130)
                        {
                            context.toolbarButtons.push(allBtns[i]);
                            width -= 130;
                        }
                        else
                            context.moreActionButtons.push(allBtns[i]);
                    }
                }

                window.onresize = () => { onResize() }
                if (fireResize)
                {
                    this.$nextTick(() => {
                        onResize();
                    });
                }
            },
            cancelCorrespondence(documentId)
            {
                window.showInformation(
                this.$t("res_Msg_DeleteConfirmation"),
                this.$t("res_Msgs_CloseCorrespondenceConfirmation"),
                () => {
                axios.get(constants.baseApiUrl + 'Document/CancelCorrespondence?documentId=' +
                    documentId, { headers: constants.headers })
                    .then(res =>{
                        if(res.data != null){
                            
                            window.showAlert('res_Msgs_CorrespondenceCanceled', 'success')
                        }
                    })
                    .catch(err => console.warn(err))
                }, () => {});
            },
            classificationPlanSelectChanged(obj) {
                this.classificationPlanId = obj.id != null ? obj.id : null;
            },
            markLetterAsDispatched()
            {
                window.showInformation(
                    this.$t("res_Msgs_Confirmation"),
                    this.$t("res_Msgs_MarkLetterAsDispatchedConfirmation"),
                    () => 
                    {
                        window.showLoading()
                        axios.post(constants.baseApiUrl + 'Document/MarkLetterAsDispatched?documentId=' + this.selectedItem.item.documentId 
                                + '&transferId=' + this.selectedItem.item.transferId, null)
                            .then(() => this.refreshPage())
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading());
                    },
                    () => { });
            },
            undoMarkLetterAsDispatched()
            {
                window.showInformation(
                    this.$t("res_Msgs_Confirmation"),
                    this.$t("res_Msgs_UndoMarkLetterAsDispatchedConfirmation"),
                    () => 
                    {
                        window.showLoading()
                        axios.post(constants.baseApiUrl + 'Document/UndoMarkLetterAsDispatched?documentId=' + this.selectedItem.item.documentId 
                                + '&transferId=' + this.selectedItem.item.transferId, null)
                            .then(() => this.refreshPage())
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading());
                    },
                    () => { });
            },
        getOverdueText(item) {
            if (!item || (!item.overdue && !item.newrdue && item.overdue !== 0 && item.newrdue !== 0)) return '';
            const overdueType = item.overdue != null ? item.overdue : item.newrdue;
            const days = item.overdueDays;
            if (days == null || days === '' || isNaN(days)) return '';
            const lang = this.selectedLang || 'en';
            if (lang === 'ar') {
                if (days > 0) {
                    return `متأخر منذ (${days}) يوم`;
                } else if (days === 0) {
                    return `تتأخر اليوم`;
                } else {
                    return `متبقي (${Math.abs(days)}) يوم`;
                }
            } else {
                if (days > 0) {
                    return `Overdue\nby (${days}) days`;
                } else if (days === 0) {
                    return `Overdue Today`;
                } else {
                    return `Due in (${Math.abs(days)}) days`;
                }
            }
        },
    },
    computed: 
    {
        ...mapGetters(['allDocumentCategories']),
        enableSingleSelect()
        {
            return !((this.nodeId === 2 || this.nodeId === 1 || this.nodeId === 6 || this.nodeId === 10) && window.selectMultiDocument === true);
        },
        nextDate() 
        {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + 1);
            return currentDate.toISOString().slice(0, 10); 
        },
        isSendLetterEnabled() 
        {
            if (window.sendEmailIsDispatch == true)
                return this.selectedItem.item.categoryId === 2
            else
                return true
        },
        computedLabel() {
            return sessionStorage.getItem('lang') === 'AR' ? 'nameAr' : 'name';
        }
    }
}
</script>

<style>
.v-popper--theme-tooltip {
    max-width: 400px !important;
}

.tr-bold td {
    font-weight: 600 !important;
}

.show-tooltip {
    position: relative;
    cursor: pointer;
}

.show-tooltip::before {
    content: attr(title);
    position: absolute;
    top: -20px;
    left: 0;
    background-color: #000;
    color: #fff;
    padding: 5px;
    border-radius: 3px;
    opacity: 0.8;
    /* Additional tooltip styling */
}

.inbox_tab_name {
    text-transform: none !important;
}

tr.custom-class {
    background: #F0F8FF;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

tr.custom-class .v-icon.mdi-checkbox-blank-outline:before {
    content: "";
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 4px;
    background-color: #205cdf;
    background-image: url(../assets/images/icons/tick.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px;
}

#viewerFrame {
    height: calc(100% - 39px);
}

.transparentBg {
    background: transparent !important;
}

.custom-button {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
}


.DocumentsList tr td .subjectCell {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
}

/* The .v-data-table--mobile card treatment used to be duplicated here and in
   main.css; it now lives only in main.css / main.rtl.css so the two copies
   cannot drift apart. */

#ListCorrespondancesTable table thead th.text-start  {
    background: var(--table-header-color);
}

/* The select-all header cell holds the checkbox directly, Vuetify gives it no
   inner span, so its side padding comes straight off the th. Skip it here and
   let the .cts-grid rules in main.css / main.rtl.css set it, otherwise these
   8px pull the header checkbox off the column of row checkboxes below it. */
#ListCorrespondancesTable table thead th.text-start:not(:first-child) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

/* Responsive Bulk Action Bar Styles */
.bulk-action-bar {
    transition: all 0.3s ease;
    width: 100% !important;
    box-sizing: border-box !important;
}

.bulk-actions-container {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden;
}

.bulk-action-btn {
    min-width: auto !important;
    font-size: 12px !important;
    padding: 6px 12px !important;
    margin: 2px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
}

/* Table margin adjustment when bulk actions are active */
/* .bulk-actions-active {
    margin-top: 60px; */
/* } */


@media screen and (max-width: 567px) {
	/* Dropdowns only - the mobile nav drawer (.sm-full-view) is meant to
	   cover the full width, and this cap was cutting it 10% short. */
	#app > div.v-menu__content.theme--light.menuable__content__active:not(.sm-full-view) {
		max-width: 90% !important;
	}
}


/* Large screens (desktop) */
@media (min-width: 1200px) {
    .bulk-action-btn {
        font-size: 14px !important;
        padding: 8px 16px !important;
        margin: 4px !important;
    }
    
    .bulk-actions-container {
        gap: 12px !important;
    }
}

/* Medium screens (tablet) */
@media (max-width: 1199px) and (min-width: 768px) {
    .bulk-action-btn {
        font-size: 13px !important;
        padding: 7px 14px !important;
        margin: 3px !important;
    }
    
    .bulk-actions-container {
        gap: 8px !important;
    }
}

/* Small screens (mobile) */
@media (max-width: 767px) {
    .bulk-action-bar {
        display: none;
        padding: 6px 8px !important;
    }
    
    .bulk-actions-container {
        flex-direction: column;
        gap: 4px !important;
        width: 100%;
    }
    
    .bulk-action-btn {
        width: 100% !important;
        max-width: 200px !important;
        font-size: 12px !important;
        padding: 8px 12px !important;
        margin: 2px auto !important;
    }
    
    /* Adjust table margin for mobile */
    .bulk-actions-active {
        margin-top: 120px !important;
    }
}

/* Extra small screens */
@media (max-width: 480px) {
    .bulk-action-bar {
        padding: 4px 6px !important;
    }
    
    .bulk-action-btn {
        font-size: 11px !important;
        padding: 6px 10px !important;
        max-width: 180px !important;
    }
    
    /* Adjust table margin for extra small screens */
    .bulk-actions-active {
        margin-top: 140px !important;
    }
}

@media screen and (max-width: 350px) {
    #header-dialogue-inbox-full > div{
        height: auto !important;
        display: flex;
        flex-direction: column;
        padding: 10px;
    }
	.create-document-dialog header .v-toolbar__content .toolbar-icons {
		gap: 0.5rem !important;
    }
    .v-dialog .v-toolbar .v-toolbar__content .custom-icon-wrapper .mdi-close {
	margin-left: 0 !important;
	}
}


.dispatch-row {
  background-color: #fcdbba  !important; /* light red */
}

.custom-icon-wrapper {
	width: 30px;
	height: 30px;
}

.v-icon {
  cursor: pointer;
}
.action-mobile-wrapper .mdi:before {
    line-height: 0;
}



</style>